export interface CatalogProduct { name: string; slug: string; website: string; description: string; color: string; categories: string[]; promotions: string[]; popularity: number }

export const catalog: CatalogProduct[] = [
  {
    "name": "Breezy HR",
    "slug": "breezyhr",
    "website": "https://breezy.hr",
    "description": "Recruitment and applicant tracking software designed to streamline hiring processes, improve team collaboration, and manage candidate pipelines.",
    "color": "#5cc0eb",
    "categories": [
      "HR",
      "HR Software"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 397162
  },
  {
    "name": "Deputy",
    "slug": "deputy",
    "website": "https://www.deputy.com",
    "description": "Workforce management software for employee scheduling, time tracking, and task management.",
    "color": "#0C017B",
    "categories": [
      "Collaboration & Productivity",
      "HR"
    ],
    "promotions": [],
    "popularity": 326156
  },
  {
    "name": "Printify",
    "slug": "printify",
    "website": "https://www.printify.com",
    "description": "Print-on-demand platform that allows businesses to design and sell custom products, with integrated fulfillment and shipping.",
    "color": "#D1D1C7",
    "categories": [
      "Marketing",
      "Collaboration & Productivity",
      "Commerce",
      "Design",
      "E-Commerce"
    ],
    "promotions": [],
    "popularity": 282798
  },
  {
    "name": "Bar Codes Talk",
    "slug": "barcodestalk",
    "website": "https://www.barcodestalk.com/",
    "description": "Barcode generator and inventory management software that helps businesses track products, shipments, and stock levels using barcode scanning.",
    "color": "#000000",
    "categories": [
      "Other",
      "Office Software",
      "Customer Service"
    ],
    "promotions": [],
    "popularity": 138139
  },
  {
    "name": "Eleven Labs Inc.",
    "slug": "elevenlabsinc",
    "website": "https://elevenlabs.io",
    "description": "AI-driven text-to-speech technology that creates realistic and emotional voiceovers.",
    "color": "#000000",
    "categories": [
      "Content Management",
      "HR Software",
      "Collaboration & Productivity",
      "Development",
      "Digital Advertising"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 115020
  },
  {
    "name": "AdCreative.ai",
    "slug": "adcreative",
    "website": "https://www.adcreative.ai/",
    "description": "AI-driven ad design platform that helps businesses create optimized, high-converting ads for multiple platforms with minimal effort.",
    "color": "#3B2A82",
    "categories": [
      "Design",
      "Artificial Intelligence",
      "Digital Advertising",
      "Office Software",
      "Marketing"
    ],
    "promotions": [],
    "popularity": 83791
  },
  {
    "name": "Switcher Studio",
    "slug": "switcherinc",
    "website": "https://www.switcherstudio.com",
    "description": "Video production platform that enables businesses to create live-streaming content with multi-camera support.",
    "color": "#042C3B",
    "categories": [
      "Social Media",
      "Hosting Providers",
      "Marketing",
      "Commerce",
      "Sales"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 58447
  },
  {
    "name": "Brevo",
    "slug": "brevo",
    "website": "https://www.brevo.com",
    "description": "Email marketing and automation platform that enables businesses to send personalized emails, create workflows, and track customer interactions.",
    "color": "#D7FEC8",
    "categories": [
      "Analytics",
      "Collaboration & Productivity",
      "Sales",
      "Marketing"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 40578
  },
  {
    "name": "Gorgias",
    "slug": "gorgias",
    "website": "https://gorgias.com",
    "description": "Customer support platform for e-commerce businesses that centralizes all customer interactions from email, social, and live chat in one interface.",
    "color": "#ff9780",
    "categories": [
      "E-Commerce",
      "Customer Service"
    ],
    "promotions": [],
    "popularity": 38305
  },
  {
    "name": "BILL",
    "slug": "bill",
    "website": "https://www.bill.com",
    "description": "Leading financial operations platform that streamlines AP/AR, spend, and expense management—trusted by nearly half a million businesses to automate payments, control cash flow, and boost efficiency.",
    "color": "#ff5a0a",
    "categories": [
      "Vertical Industry Software",
      "Accounting",
      "Trending"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 34471
  },
  {
    "name": "Dext",
    "slug": "dext",
    "website": "https://dext.com/",
    "description": "Financial software for automating bookkeeping, accounting, and receipt management for small businesses.",
    "color": "#FF5A02",
    "categories": [
      "Commerce",
      "Office Software",
      "IT Management",
      "Data Privacy",
      "Customer Service"
    ],
    "promotions": [],
    "popularity": 33089
  },
  {
    "name": "QuickBooks",
    "slug": "quickbooks",
    "website": "https://quickbooks.intuit.com/partners/qbbusinessaffiliates/",
    "description": "Accounting software for small businesses that helps with bookkeeping, invoicing, payroll, and financial reporting.",
    "color": "#169f39",
    "categories": [
      "Sales",
      "Analytics",
      "HR Software",
      "Office Software",
      "ERP"
    ],
    "promotions": [],
    "popularity": 30519
  },
  {
    "name": "Kit (formerly ConvertKit)",
    "slug": "kit",
    "website": "https://kit.com/",
    "description": "Kit helps creators automate and monetize their email marketing so they can focus on creating content and serving their audience.",
    "color": "#44B1FF",
    "categories": [
      "Office Software",
      "Sales",
      "Commerce",
      "Digital Advertising",
      "Marketing"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 28447
  },
  {
    "name": "Spocket",
    "slug": "spocket",
    "website": "https://www.spocket.co/",
    "description": "Dropshipping platform that connects e-commerce businesses to suppliers and helps manage product sourcing and fulfillment processes.",
    "color": "#8144E5",
    "categories": [
      "B2B Marketplaces",
      "Commerce",
      "Supply Chain & Logistics",
      "E-Commerce"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 28145
  },
  {
    "name": "Wati.io",
    "slug": "watiio",
    "website": "https://www.wati.io/",
    "description": "WhatsApp-based customer support and communication platform.",
    "color": "#00E785",
    "categories": [
      "Customer Service",
      "Analytics",
      "Artificial Intelligence",
      "Digital Advertising",
      "Sales"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 27561
  },
  {
    "name": "Leadpages",
    "slug": "leadpages",
    "website": "https://www.leadpages.com",
    "description": "Landing page creation platform designed to help businesses capture leads, increase conversions, and drive more sales through optimized pages.",
    "color": "#603eff",
    "categories": [
      "Office Software",
      "Design",
      "Sales",
      "Digital Advertising",
      "Artificial Intelligence"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 26257
  },
  {
    "name": "Flippa.com",
    "slug": "flippacom",
    "website": "https://Flippa.com",
    "description": "Marketplace for buying and selling online businesses, websites, and digital assets.",
    "color": "#001F44",
    "categories": [
      "B2B Marketplaces",
      "E-Commerce",
      "Other"
    ],
    "promotions": [],
    "popularity": 24616
  },
  {
    "name": "monday.com",
    "slug": "mondaycom",
    "website": "https://monday.com",
    "description": "Work operating system that helps teams manage projects, workflows, and everyday tasks with customizable boards and automation tools.",
    "color": "#030069",
    "categories": [
      "Collaboration & Productivity"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 23370
  },
  {
    "name": "Proof",
    "slug": "proof",
    "website": "https://useproof.com",
    "description": "A conversion optimization platform that uses social proof notifications to increase website conversion rates by displaying real-time activity.",
    "color": "#0c0c5b",
    "categories": [],
    "promotions": [],
    "popularity": 19632
  },
  {
    "name": "Moosend",
    "slug": "moosend",
    "website": "https://moosend.com",
    "description": "Email marketing automation platform that enables businesses to create, send, and analyze campaigns for better customer engagement.",
    "color": "#12277D",
    "categories": [
      "Marketing",
      "Digital Advertising",
      "Commerce"
    ],
    "promotions": [],
    "popularity": 19270
  },
  {
    "name": "Gamma",
    "slug": "gammaapp",
    "website": "https://gamma.app",
    "description": "Gamma is your AI design partner for creating presentations, websites, social media, and more. All at the speed of thought.",
    "color": "#1862D4",
    "categories": [
      "Sales",
      "Office Software",
      "Design",
      "Marketing",
      "Collaboration & Productivity"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 19192
  },
  {
    "name": "PartnerStack",
    "slug": "partners",
    "website": "https://partnerstack.com",
    "description": "Partnership management platform that enables businesses to recruit, manage, and track affiliates, resellers, and other partners.",
    "color": "#434EE1",
    "categories": [
      "B2B Marketplaces",
      "IT Management",
      "Sales",
      "Collaboration & Productivity",
      "Marketing"
    ],
    "promotions": [],
    "popularity": 19006
  },
  {
    "name": "Outgrow",
    "slug": "outgrow",
    "website": "https://outgrow.co",
    "description": "Interactive content platform that helps businesses create quizzes, calculators, and assessments to engage customers and generate leads.",
    "color": "#f06067",
    "categories": [
      "Sales",
      "Marketing",
      "Customer Service"
    ],
    "promotions": [],
    "popularity": 16531
  },
  {
    "name": "Sellfy",
    "slug": "sellfy",
    "website": "https://sellfy.com",
    "description": "E-commerce platform that allows creators to sell digital products, subscriptions, and services directly to their audience.",
    "color": "#26BF26",
    "categories": [
      "Commerce",
      "Sales",
      "Marketing",
      "E-Commerce"
    ],
    "promotions": [],
    "popularity": 16469
  },
  {
    "name": "Webflow",
    "slug": "webflow",
    "website": "https://www.webflow.com",
    "description": "Web design and development platform that allows users to design, build, and launch responsive websites without coding.",
    "color": "#136EF4",
    "categories": [
      "Development",
      "Collaboration & Productivity"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 15418
  },
  {
    "name": "Bright Data",
    "slug": "brightdata",
    "website": "https://brightdata.com",
    "description": "Web data platform for collecting structuring any public web data from any location without blocks.",
    "color": "#00b3ff",
    "categories": [
      "Collaboration & Productivity",
      "Development",
      "Sales",
      "Marketing"
    ],
    "promotions": [],
    "popularity": 15111
  },
  {
    "name": "Thinkific",
    "slug": "thinkific6979",
    "website": "https://www.thinkific.com",
    "description": "Create, deliver, and monetize courses, training programs, certifications, communities, memberships, and digital products from a single learning platform.",
    "color": "#271526",
    "categories": [
      "Collaboration & Productivity",
      "Development",
      "Content Management",
      "Artificial Intelligence",
      "Marketing"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 14896
  },
  {
    "name": "Apollo.io",
    "slug": "apollo",
    "website": "https://apollo.io",
    "description": "Sales intelligence platform that provides data on leads, companies, and contacts, helping teams with prospecting, outreach, and engagement.",
    "color": "#1A1A1A",
    "categories": [
      "Sales",
      "Marketing"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 14404
  },
  {
    "name": "PandaDoc",
    "slug": "pandadoc",
    "website": "https://pandadoc.com",
    "description": "Document automation platform that helps businesses create, distribute, and sign contracts and proposals online.",
    "color": "#238768",
    "categories": [
      "Sales"
    ],
    "promotions": [],
    "popularity": 14396
  },
  {
    "name": "Instapage",
    "slug": "instapage",
    "website": "https://instapage.com",
    "description": "Landing page builder designed to help businesses create, personalize, and optimize high-converting pages for marketing campaigns.",
    "color": "#06135B",
    "categories": [
      "Sales",
      "Marketing"
    ],
    "promotions": [],
    "popularity": 13696
  },
  {
    "name": "Xero",
    "slug": "xero5440",
    "website": "https://www.xero.com",
    "description": "Cloud-based accounting software for managing business finances.",
    "color": "#13B5EA",
    "categories": [
      "Accounting"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 13359
  },
  {
    "name": "QuillBot",
    "slug": "quillbot",
    "website": "https://quillbot.com/",
    "description": "AI-powered writing assistant that helps users paraphrase, summarize, and improve their writing through suggestions and grammar checks.",
    "color": "#469654",
    "categories": [
      "Collaboration & Productivity",
      "Artificial Intelligence",
      "Content Management",
      "Office Software",
      "Marketing"
    ],
    "promotions": [],
    "popularity": 13074
  },
  {
    "name": "LearnWorlds - Top User-rated  Online Course Platform & LMS",
    "slug": "learnworlds",
    "website": "https://www.learnworlds.com/?utm_source=partnerstack&utm_medium=marketplace",
    "description": "Online course creation platform with integrated tools for selling and managing courses.",
    "color": "#02CFC0",
    "categories": [
      "Digital Advertising",
      "Artificial Intelligence",
      "Design",
      "Development",
      "Content Management"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 12971
  },
  {
    "name": "Softr",
    "slug": "softrplatformsgmbh",
    "website": "https://www.softr.io",
    "description": "No-code platform enabling users to build web applications, marketplaces, and internal tools without writing code.",
    "color": "#386AF5",
    "categories": [
      "Collaboration & Productivity",
      "Development",
      "HR Software",
      "B2B Marketplaces",
      "IT Management"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 11802
  },
  {
    "name": "Trainual",
    "slug": "trainual",
    "website": "https://trainual.com",
    "description": "Employee training and onboarding platform that helps businesses create, distribute, and manage training materials and workflows.",
    "color": "#7322F1",
    "categories": [
      "B2B Marketplaces",
      "Office Software",
      "Collaboration & Productivity",
      "HR Software",
      "Artificial Intelligence"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 11793
  },
  {
    "name": "Credit Repair Cloud",
    "slug": "creditrepaircloud",
    "website": "https://www.creditrepaircloud.com/",
    "description": "Software for credit repair businesses to manage clients, automate tasks, and track credit repair progress through a centralized platform.",
    "color": "#003595",
    "categories": [
      "Customer Service"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 10506
  },
  {
    "name": "airSlate",
    "slug": "airslate",
    "website": "https://www.airslate.com/about",
    "description": "Document automation platform that streamlines business workflows by integrating forms, e-signatures, and document management features.",
    "color": "#E9F1FF",
    "categories": [
      "Office Software",
      "Content Management"
    ],
    "promotions": [],
    "popularity": 10322
  },
  {
    "name": "GetResponse",
    "slug": "getresponse",
    "website": "https://www.getresponse.com",
    "description": "All-in-one marketing software for marketers solopreneurs to grow audiences sell courses.",
    "color": "#00A2FF",
    "categories": [
      "Artificial Intelligence",
      "Marketing",
      "Sales",
      "Trending",
      "Vertical Industry Software"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 9625
  },
  {
    "name": "Murf AI",
    "slug": "murfai",
    "website": "https://murf.ai",
    "description": "AI-powered voiceover tool that allows users to create realistic, human-like voiceovers from text for podcasts, videos, and other content.",
    "color": "#3A4358",
    "categories": [
      "Collaboration & Productivity",
      "B2B Marketplaces",
      "Artificial Intelligence",
      "Content Management",
      "Marketing"
    ],
    "promotions": [],
    "popularity": 9473
  },
  {
    "name": "Keap",
    "slug": "keap",
    "website": "https://keap.com",
    "description": "CRM and marketing automation platform designed for small businesses to manage leads, sales, and customer relationships.",
    "color": "#36A635",
    "categories": [
      "Sales",
      "Marketing",
      "Office Software",
      "Customer Service"
    ],
    "promotions": [],
    "popularity": 9173
  },
  {
    "name": "ClickUp",
    "slug": "clickup",
    "website": "https://www.clickup.com/lp",
    "description": "Project management and productivity platform designed to help teams collaborate, plan, and execute tasks with customizable workflows.",
    "color": "#49CCF9",
    "categories": [
      "Collaboration & Productivity",
      "Office Software",
      "B2B Marketplaces",
      "Artificial Intelligence"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 8865
  },
  {
    "name": "Manychat",
    "slug": "manychat",
    "website": "https://manychat.com/",
    "description": "Platform for building and automating chatbots across messaging apps like Facebook, SMS, and email.",
    "color": "#000",
    "categories": [
      "Customer Service",
      "Artificial Intelligence",
      "Vertical Industry Software",
      "Office Software",
      "IoT Management"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 8150
  },
  {
    "name": "Pixel Union & Out of the Sandbox",
    "slug": "pixelunion",
    "website": "https://outofthesandbox.com/pages/affiliate-program",
    "description": "Design agency providing customizable Shopify themes and e-commerce solutions to help businesses create and manage online stores.",
    "color": "#3D63C4",
    "categories": [
      "Commerce",
      "E-Commerce"
    ],
    "promotions": [],
    "popularity": 7817
  },
  {
    "name": "Connecteam",
    "slug": "connecteam",
    "website": "https://connecteam.com",
    "description": "Workforce management platform that helps businesses manage employees through scheduling, task assignments, time tracking, and communication tools.",
    "color": "#3c3679",
    "categories": [
      "Collaboration & Productivity",
      "Other",
      "HR",
      "HR Software",
      "Supply Chain & Logistics"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 7811
  },
  {
    "name": "Deel",
    "slug": "deel",
    "website": "https://www.deel.com/",
    "description": "Global payroll and compliance platform that helps businesses onboard, pay, and manage remote workers and contractors in multiple countries.",
    "color": "#C4B1F9",
    "categories": [
      "HR Software",
      "Payroll",
      "HR"
    ],
    "promotions": [],
    "popularity": 7744
  },
  {
    "name": "Answering Service Care, LLC",
    "slug": "answeringservicecarellc",
    "website": "https://answeringservicecare.com",
    "description": "Provider of live answering services, virtual receptionist, and call center solutions for businesses.",
    "color": "#203368",
    "categories": [
      "Collaboration & Productivity",
      "IT Management",
      "Office Software",
      "Sales",
      "Vertical Industry Software"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 7707
  },
  {
    "name": "Streak - CRM for Gmail",
    "slug": "streak",
    "website": "https://www.streak.com?utm_source=growsumo&utm_medium=lp&utm_campaign=gs+referral+lp",
    "description": "CRM tool integrated directly with Gmail that helps businesses manage customer relationships, track emails, and automate sales processes.",
    "color": "#EF692B",
    "categories": [
      "Sales",
      "Collaboration & Productivity",
      "Office Software",
      "Marketing"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 7657
  },
  {
    "name": "SocialBee",
    "slug": "socialbee",
    "website": "https://socialbee.com/",
    "description": "Social media management platform designed to help businesses schedule, curate, and post content while tracking engagement and performance.",
    "color": "#333333",
    "categories": [
      "Social Media",
      "Marketing",
      "Content Management",
      "B2B Marketplaces",
      "Collaboration & Productivity"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 7473
  },
  {
    "name": "Descript",
    "slug": "descriptinc",
    "website": "https://www.descript.com",
    "description": "AI-powered tool for creating and editing audio and video",
    "color": "#F73B3B",
    "categories": [
      "Artificial Intelligence",
      "Trending",
      "Collaboration & Productivity"
    ],
    "promotions": [],
    "popularity": 7448
  },
  {
    "name": "Castmagic",
    "slug": "castmagic",
    "website": "https://castmagic.io",
    "description": "AI-driven platform that transcribes, edits, and repurposes podcast content into written articles, videos, and social media posts.",
    "color": "#AFC5E2",
    "categories": [
      "Marketing",
      "Content Management",
      "Development",
      "Digital Advertising",
      "Design"
    ],
    "promotions": [],
    "popularity": 7270
  },
  {
    "name": "Subbly",
    "slug": "subbly",
    "website": "https://www.subbly.co",
    "description": "Subscription box platform that enables businesses to launch, manage, and scale their subscription-based services.",
    "color": "#16A480",
    "categories": [
      "Commerce",
      "E-Commerce"
    ],
    "promotions": [],
    "popularity": 7026
  },
  {
    "name": "CallRail",
    "slug": "callrail",
    "website": "https://callrail.com",
    "description": "Call tracking and analytics platform that helps businesses track and analyze inbound calls to improve marketing ROI and customer insights.",
    "color": "#126cd3",
    "categories": [
      "Marketing",
      "Artificial Intelligence",
      "Digital Advertising",
      "Analytics"
    ],
    "promotions": [],
    "popularity": 6902
  },
  {
    "name": "Unbounce",
    "slug": "unbounce",
    "website": "https://www.unbounce.com",
    "description": "Landing page builder designed to help marketers create high-converting pages quickly with customizable templates and A/B testing tools.",
    "color": "#0033FF",
    "categories": [
      "Collaboration & Productivity",
      "Development",
      "Digital Advertising",
      "Content Management",
      "Analytics"
    ],
    "promotions": [],
    "popularity": 6695
  },
  {
    "name": "Gravity",
    "slug": "gravity",
    "website": "https://gravityforms.com/",
    "description": "Gravity Forms is a powerful WordPress form builder that helps businesses collect leads, payments, and data using flexible forms, workflows, and integrations—without custom development.",
    "color": "#ff4f00",
    "categories": [
      "Development",
      "Customer Service",
      "Content Management",
      "Collaboration & Productivity",
      "Marketing"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 6490
  },
  {
    "name": "Pipedrive",
    "slug": "pipedrive",
    "website": "https://www.pipedrive.com",
    "description": "CRM software designed to help sales teams manage leads, track progress, and automate tasks to increase productivity and close deals faster.",
    "color": "#26292C",
    "categories": [
      "Sales",
      "B2B Marketplaces"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 6027
  },
  {
    "name": "Glide",
    "slug": "glide",
    "website": "https://www.glideapps.com",
    "description": "No-code app builder that enables users to create mobile and web apps directly from Google Sheets data.",
    "color": "#18BED4",
    "categories": [
      "IT Management",
      "Marketing",
      "IoT Management",
      "Supply Chain & Logistics",
      "HR Software"
    ],
    "promotions": [],
    "popularity": 6016
  },
  {
    "name": "Leadfeeder",
    "slug": "leadfeeder",
    "website": "https://www.leadfeeder.com/",
    "description": "Sales engagement platform focused on helping businesses close deals faster with automation.",
    "color": "#FEFEFE",
    "categories": [
      "Analytics",
      "Marketing"
    ],
    "promotions": [],
    "popularity": 5757
  },
  {
    "name": "Todoist",
    "slug": "doist",
    "website": "https://www.todoist.com",
    "description": "Task and project management tool that helps users organize and prioritize tasks with simple and intuitive task lists and reminders.",
    "color": "#FFFFFF",
    "categories": [
      "Collaboration & Productivity"
    ],
    "promotions": [],
    "popularity": 5717
  },
  {
    "name": "Freshdesk by Freshworks",
    "slug": "freshdesk",
    "website": "https://freshdesk.com",
    "description": "Customer support and helpdesk platform that helps businesses manage tickets, live chats, and support queries across multiple channels.",
    "color": "#00bf6f",
    "categories": [
      "Vertical Industry Software",
      "Customer Service"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 5514
  },
  {
    "name": "8fig",
    "slug": "8fig",
    "website": "https://www.8fig.co/",
    "description": "Financial planning and forecasting platform that helps e-commerce businesses scale by optimizing cash flow and funding.",
    "color": "#0E1122",
    "categories": [
      "Sales",
      "Supply Chain & Logistics",
      "Commerce",
      "Collaboration & Productivity",
      "E-Commerce"
    ],
    "promotions": [],
    "popularity": 5335
  },
  {
    "name": "Freshservice by Freshworks",
    "slug": "freshservice",
    "website": "https://www.freshworks.com/freshservice/",
    "description": "IT service management software that helps businesses streamline incident management, workflows, and service requests for internal teams.",
    "color": "#1592D0",
    "categories": [
      "Customer Service",
      "Vertical Industry Software",
      "Office Software",
      "IT Management"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 5302
  },
  {
    "name": "Landbot",
    "slug": "landbot",
    "website": "https://landbot.io",
    "description": "No-code chatbot builder that allows businesses to create conversational landing pages and automate customer support via messaging.",
    "color": "#FF3F7B",
    "categories": [
      "Commerce",
      "Marketing",
      "Sales",
      "Digital Advertising",
      "Customer Service"
    ],
    "promotions": [],
    "popularity": 5268
  },
  {
    "name": "Shor affiliate program",
    "slug": "shorby",
    "website": "https://shor.by/about-shor",
    "description": "A platform that lets you create high-converting, link-based landing pages to promote tools and earn commissions for each referral.",
    "color": "#6f1e86",
    "categories": [
      "Marketing",
      "Customer Service"
    ],
    "promotions": [],
    "popularity": 5221
  },
  {
    "name": "Instantly",
    "slug": "instantly",
    "website": "https://instantly.ai",
    "description": "Leading cold email platform trusted by agencies and founders. Earn recurring commissions by promoting a tool that boosts deliverability, scales outreach, and drives real results.",
    "color": "#326DE4",
    "categories": [
      "Sales",
      "Digital Advertising",
      "Artificial Intelligence",
      "Marketing"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 5147
  },
  {
    "name": "Airwallex",
    "slug": "airwallex",
    "website": "https://www.airwallex.com",
    "description": "Partner with one of the fastest growing international fintech companies leading the charge in redefining global banking.",
    "color": "#FF4244",
    "categories": [
      "Accounting",
      "Payroll",
      "Governance, Risk, & Compliance",
      "Sales",
      "B2B Marketplaces"
    ],
    "promotions": [],
    "popularity": 5106
  },
  {
    "name": "Alidrop",
    "slug": "alidrop",
    "website": "https://alidrop.co/",
    "description": "👉 Automated order processing 👉 US/EU supplier options for faster shipping 👉 AI tools for product descriptions and optimization 🚀 Start scaling your dropshipping business with ease!",
    "color": "#F2441F",
    "categories": [
      "E-Commerce",
      "Artificial Intelligence",
      "Sales",
      "Commerce"
    ],
    "promotions": [],
    "popularity": 5040
  },
  {
    "name": "Surfer",
    "slug": "surferseo",
    "website": "https://surferseo.com",
    "description": "SEO tool that helps businesses optimize their websites by analyzing keyword rankings, competition, and other on-page SEO factors.",
    "color": "#783afb",
    "categories": [
      "Digital Advertising",
      "Content Management",
      "Marketing",
      "B2B Marketplaces"
    ],
    "promotions": [],
    "popularity": 5040
  },
  {
    "name": "Ticket Tailor",
    "slug": "tickettailor",
    "website": "https://www.tickettailor.com",
    "description": "Ticketing platform that helps event organizers sell tickets online and manage events without paying high fees.",
    "color": "#FFC8BA",
    "categories": [
      "Vertical Industry Software",
      "Sales",
      "Commerce",
      "Marketing",
      "Other"
    ],
    "promotions": [],
    "popularity": 5033
  },
  {
    "name": "SurveySparrow",
    "slug": "surveysparrow",
    "website": "https://surveysparrow.com",
    "description": "Survey platform that helps businesses create engaging surveys, collect feedback, and analyze responses to improve customer experience.",
    "color": "#56AFBA",
    "categories": [
      "B2B Marketplaces",
      "Collaboration & Productivity",
      "Marketing",
      "Customer Service"
    ],
    "promotions": [],
    "popularity": 4995
  },
  {
    "name": "Brand24",
    "slug": "brand24",
    "website": "https://www.brand24.com",
    "description": "Social media monitoring tool that tracks online mentions and helps businesses measure their brand reputation and engagement.",
    "color": "#00d28c",
    "categories": [
      "Commerce",
      "Sales",
      "Customer Service",
      "Artificial Intelligence",
      "Analytics"
    ],
    "promotions": [],
    "popularity": 4949
  },
  {
    "name": "Livestorm",
    "slug": "livestorm",
    "website": "https://livestorm.co/",
    "description": "Web conferencing and webinar platform that helps businesses host online meetings, webinars, and virtual events with ease.",
    "color": "#FFFFFF",
    "categories": [
      "Collaboration & Productivity",
      "Sales",
      "Marketing",
      "Content Management"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 4866
  },
  {
    "name": "Dripify",
    "slug": "dripify",
    "website": "https://dripify.com/",
    "description": "AI-powered LinkedIn automation tool for streamlining hiring, sales, marketing processes.",
    "color": "#BCB0FC",
    "categories": [
      "Marketing",
      "Sales"
    ],
    "promotions": [],
    "popularity": 4842
  },
  {
    "name": "Aircall Inc.",
    "slug": "aircall",
    "website": "https://www.aircall.io",
    "description": "Cloud-based phone and call-center platform that helps teams manage calls, messages and support with smart routing, integrations and real-time analytics to improve customer conversations.",
    "color": "#00B388",
    "categories": [
      "Sales",
      "Commerce",
      "Analytics",
      "Customer Service",
      "Artificial Intelligence"
    ],
    "promotions": [],
    "popularity": 4815
  },
  {
    "name": "Reclaim.ai",
    "slug": "reclaim",
    "website": "https://reclaim.ai/",
    "description": "The #1 AI calendar app that saves you 7.6 hours/week. Automatically protect focus time, time block tasks, optimize meetings, sync calendars, analyze productivity, and improve your work-life balance on Google Calendar and Outlook Calendar.",
    "color": "#5562eb",
    "categories": [
      "Collaboration & Productivity",
      "Artificial Intelligence",
      "Customer Service",
      "Sales",
      "ERP"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 4797
  },
  {
    "name": "Hello Bar & Subscribers",
    "slug": "hellomade",
    "website": "https://www.hellobar.com",
    "description": "Conversion optimization tool that helps websites increase signups, build email lists, and boost engagement using pop-ups and bars.",
    "color": "#E8562A",
    "categories": [
      "Marketing",
      "Sales",
      "Digital Advertising",
      "B2B Marketplaces"
    ],
    "promotions": [],
    "popularity": 4586
  },
  {
    "name": "Ignition",
    "slug": "practiceignition",
    "website": "https://www.ignitionapp.com/",
    "description": "Ignition helps professional services sell, onboard, and get paid faster through automated proposals, contracts, billing, and payments.",
    "color": "#15514D",
    "categories": [
      "Customer Service",
      "Vertical Industry Software",
      "Collaboration & Productivity",
      "Artificial Intelligence",
      "Office Software"
    ],
    "promotions": [],
    "popularity": 4583
  },
  {
    "name": "Thryv",
    "slug": "thryv",
    "website": "https://www.Thryv.com/partners",
    "description": "All-in-one business management software that helps small businesses with scheduling, marketing, CRM, invoicing, and more.",
    "color": "#ff5000",
    "categories": [
      "Marketing",
      "Collaboration & Productivity",
      "Office Software",
      "Digital Advertising",
      "Hosting Providers"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 4043
  },
  {
    "name": "CloudTalk",
    "slug": "cloudtalk",
    "website": "https://www.cloudtalk.io",
    "description": "Cloudtalk is an AI-Business Communication platform that allows you to connect to customers with human or AI Agents, with +100 Native Integrations and local numbers for +160 countries",
    "color": "#0026FF",
    "categories": [
      "Customer Service",
      "Artificial Intelligence",
      "Sales"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 4041
  },
  {
    "name": "Close",
    "slug": "close",
    "website": "https://close.com",
    "description": "CRM designed to help sales teams manage leads, automate follow-ups, and track customer interactions directly from a unified platform.",
    "color": "#000000",
    "categories": [
      "Sales",
      "Marketing",
      "Collaboration & Productivity",
      "Analytics",
      "Office Software"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 3882
  },
  {
    "name": "1Password",
    "slug": "1password",
    "website": "https://1password.com/",
    "description": "Password manager that helps individuals and teams store, organize, and securely share passwords and other sensitive information.",
    "color": "#1a285f",
    "categories": [
      "Security"
    ],
    "promotions": [],
    "popularity": 3767
  },
  {
    "name": "SaneBox",
    "slug": "sanebox",
    "website": "https://www.sanebox.com",
    "description": "Email management tool that uses AI to help users organize and prioritize their inbox, reducing email overload and improving productivity.",
    "color": "#1F68DD",
    "categories": [
      "Collaboration & Productivity",
      "Marketing",
      "HR Software",
      "Office Software",
      "Customer Service"
    ],
    "promotions": [],
    "popularity": 3763
  },
  {
    "name": "CallHippo",
    "slug": "callhippo",
    "website": "https://callhippo.com",
    "description": "CallHippo is a business communication automation platform that unifies virtual calls, WhatsApp, email, chat, and social media in one dashboard. Features AI Voice Agents for automated lead qualification, AI Copilot for automation, Parallel Dialers for 3x more connections, real-time sentiment analysis, and smart routing. Transform your communication strategy with automated processes and seamless omnichannel experiences.",
    "color": "#E27849",
    "categories": [
      "Marketing",
      "Customer Service",
      "Sales",
      "Office Software"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 3761
  },
  {
    "name": "HiBob",
    "slug": "hibob",
    "website": "https://www.hibob.com",
    "description": "HR platform that simplifies employee management with tools for onboarding, payroll, and employee engagement.",
    "color": "#EE164F",
    "categories": [
      "HR Software",
      "HR"
    ],
    "promotions": [],
    "popularity": 3706
  },
  {
    "name": "Similarweb",
    "slug": "similarweb",
    "website": "https://www.similarweb.com",
    "description": "Competitive intelligence platform providing web traffic and engagement data for businesses to analyze their competitors.",
    "color": "#0E77EF",
    "categories": [
      "Commerce",
      "Marketing",
      "Analytics"
    ],
    "promotions": [],
    "popularity": 3700
  },
  {
    "name": "respond.io",
    "slug": "respondio",
    "website": "https://www.respond.io",
    "description": "Messaging platform that integrates multiple chat apps into one interface, helping businesses streamline communication with customers.",
    "color": "#0075FF",
    "categories": [
      "Artificial Intelligence",
      "Sales",
      "Collaboration & Productivity",
      "Commerce",
      "Customer Service"
    ],
    "promotions": [],
    "popularity": 3618
  },
  {
    "name": "Fastmail",
    "slug": "fastmail",
    "website": "https://www.fastmail.com",
    "description": "Email service offering custom domains, advanced security features, and powerful search functionality for users seeking privacy and productivity.",
    "color": "#0067B9",
    "categories": [
      "Office Software",
      "B2B Marketplaces",
      "Vertical Industry Software",
      "Collaboration & Productivity",
      "HR Software"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 3568
  },
  {
    "name": "VisualCV",
    "slug": "visualcv",
    "website": "https://visualcv.com",
    "description": "Resume building and design platform that allows users to create and customize professional resumes and portfolios.",
    "color": "#42A9FF",
    "categories": [
      "Design"
    ],
    "promotions": [],
    "popularity": 3495
  },
  {
    "name": "Seamless",
    "slug": "seamlessai",
    "website": "https://seamless.ai",
    "description": "AI-powered lead generation platform that helps sales teams find and engage with decision-makers.",
    "color": "#880763",
    "categories": [
      "B2B Marketplaces",
      "Sales",
      "Artificial Intelligence"
    ],
    "promotions": [],
    "popularity": 3404
  },
  {
    "name": "Shippo",
    "slug": "shippo",
    "website": "https://goshippo.com/",
    "description": "Software comparing multi‑carrier shipping rates and printing labels.",
    "color": "#2BCC8A",
    "categories": [
      "Commerce",
      "Supply Chain & Logistics",
      "E-Commerce",
      "Collaboration & Productivity"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 3363
  },
  {
    "name": "Housecall Pro",
    "slug": "housecallpro",
    "website": "https://www.housecallpro.com/",
    "description": "Field service management software that helps businesses manage appointments, invoicing, and payments for home service providers.",
    "color": "#0e253a",
    "categories": [
      "Marketing",
      "Collaboration & Productivity",
      "Vertical Industry Software",
      "Sales",
      "Customer Service"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 3321
  },
  {
    "name": "ActiveCampaign",
    "slug": "activecampaign",
    "website": "https://www.activecampaign.com/",
    "description": "ActiveCampaign is an autonomous marketing platform that uses AI to help businesses grow. The platform unifies email marketing, CRM, and marketing automation to optimize customer journeys, manage relationships, and deliver personalized experiences across multiple channels like email, SMS, and WhatsApp.",
    "color": "#4365FF",
    "categories": [
      "Customer Service",
      "Marketing",
      "Sales",
      "Office Software",
      "Development"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 3315
  },
  {
    "name": "NiceJob",
    "slug": "nicejob",
    "website": "https://get.nicejob.com/?utm_source=Partnerstack&utm_medium=NiceJobProfile&utm_campaign=marketplace",
    "description": "Reputation management platform that helps businesses collect and showcase customer reviews to improve their online reputation.",
    "color": "#673AB7",
    "categories": [
      "Marketing",
      "Customer Service",
      "Content Management",
      "Office Software",
      "Sales"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 3262
  },
  {
    "name": "Emergent Labs Inc",
    "slug": "emergentlabsinc",
    "website": "https://www.emergent.sh/",
    "description": "Emergent is the world’s first agentic vibe coding platform where anyone can turn an idea into a full-stack, production-ready app simply by chatting with AI. The platform is used by 2.5M+ builders worldwide, from solopreneurs, creators to business owners.",
    "color": "#02090C",
    "categories": [
      "Development",
      "Artificial Intelligence",
      "Trending",
      "ERP",
      "Content Management"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 3253
  },
  {
    "name": "Circle",
    "slug": "circleco",
    "website": "https://circle.so",
    "description": "Circle is the AI-powered home for your community. From a branded website to discussions, courses, events, payments, email marketing, AI agents, and more, Circle gives you everything you need to build and scale your community-led business.",
    "color": "#080405",
    "categories": [
      "Commerce",
      "Content Management",
      "B2B Marketplaces",
      "Marketing",
      "Collaboration & Productivity"
    ],
    "promotions": [],
    "popularity": 3183
  },
  {
    "name": "Tidio",
    "slug": "tidiollc",
    "website": "https://www.tidio.com",
    "description": "Tidio is an AI customer support platform (Lyro AI Agent, live chat, ticketing) trusted by 300K+ businesses. Free plan converts cold traffic easily. Ideal for ecommerce, SaaS & CX audiences.",
    "color": "#001433",
    "categories": [
      "Artificial Intelligence",
      "Customer Service",
      "Commerce",
      "E-Commerce"
    ],
    "promotions": [],
    "popularity": 3112
  },
  {
    "name": "lemlist",
    "slug": "lemlist",
    "website": "https://lemlist.com",
    "description": "Platform for automating, personalizing, and tracking cold email outreach and follow-ups",
    "color": "#2756CE",
    "categories": [
      "Marketing",
      "Sales"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 3031
  },
  {
    "name": "Process Street",
    "slug": "processstreet",
    "website": "https://www.process.st",
    "description": "Workflow and process management platform that allows businesses to automate recurring tasks and streamline team operations.",
    "color": "#173f35",
    "categories": [
      "Office Software",
      "HR Software",
      "Collaboration & Productivity"
    ],
    "promotions": [],
    "popularity": 3026
  },
  {
    "name": "Salesflare",
    "slug": "salesflare",
    "website": "https://salesflare.com",
    "description": "CRM designed to automate data entry and help sales teams track customer relationships using AI-powered insights.",
    "color": "#0F1528",
    "categories": [
      "Sales"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 3017
  },
  {
    "name": "MarketerHire",
    "slug": "marketerhire",
    "website": "https://www.marketerhire.com",
    "description": "Platform that connects businesses with top marketing talent for freelance and project-based work.",
    "color": "#000000",
    "categories": [
      "Collaboration & Productivity",
      "Marketing",
      "Content Management",
      "B2B Marketplaces",
      "Commerce"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 2905
  },
  {
    "name": "Katana Cloud Inventory",
    "slug": "katanamrp",
    "website": "https://www.katanamrp.com",
    "description": "Inventory and manufacturing management software for small businesses, helping them track stock levels and streamline production workflows.",
    "color": "#CDBDFF",
    "categories": [
      "Supply Chain & Logistics",
      "ERP",
      "Collaboration & Productivity",
      "Vertical Industry Software",
      "E-Commerce"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 2897
  },
  {
    "name": "Tellent",
    "slug": "recruitee",
    "website": "https://tellent.com",
    "description": "Recruitment software that streamlines the hiring process, from posting job openings to managing candidates and collaborating with teams.",
    "color": "#5A1CB7",
    "categories": [
      "HR Software",
      "HR"
    ],
    "promotions": [],
    "popularity": 2878
  },
  {
    "name": "Kartra, WebinarJam & EverWebinar",
    "slug": "genesisdigital",
    "website": "https://kartra.com",
    "description": "Kartra is an all-in-one platform for building and managing online businesses. WebinarJam enables live webinars, while EverWebinar is designed for automated evergreen webinars.",
    "color": "#227bce",
    "categories": [
      "Marketing",
      "Sales"
    ],
    "promotions": [],
    "popularity": 2864
  },
  {
    "name": "Quo (formerly OpenPhone)",
    "slug": "quo",
    "website": "https://www.quo.com/",
    "description": "VoIP and business phone service designed to help teams manage calls, texts, and voicemails from a central mobile or desktop app.",
    "color": "#E9F545",
    "categories": [
      "Collaboration & Productivity",
      "Office Software",
      "Vertical Industry Software",
      "Customer Service",
      "Sales"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 2829
  },
  {
    "name": "Ownr",
    "slug": "ownr",
    "website": "https://www.ownr.co/",
    "description": "Business formation and management platform that helps entrepreneurs incorporate businesses, register trademarks, and manage compliance.",
    "color": "#5F3DC8",
    "categories": [
      "Development",
      "Collaboration & Productivity",
      "B2B Marketplaces",
      "Commerce",
      "Sales"
    ],
    "promotions": [],
    "popularity": 2823
  },
  {
    "name": "Sendcloud",
    "slug": "sendcloud",
    "website": "https://www.sendcloud.com",
    "description": "Shipping platform that simplifies e-commerce logistics by offering multi-carrier shipping, label printing, and tracking.",
    "color": "#1D97FF",
    "categories": [
      "Commerce",
      "ERP",
      "Marketing",
      "Sales",
      "E-Commerce"
    ],
    "promotions": [],
    "popularity": 2689
  },
  {
    "name": "folk",
    "slug": "folkapp",
    "website": "http://folk.app/",
    "description": "CRM platform for managing and automating business relationships, with customizable pipelines and workflows.",
    "color": "#FFFFFF",
    "categories": [
      "Sales",
      "Collaboration & Productivity",
      "Marketing"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 2676
  },
  {
    "name": "Nextiva",
    "slug": "nextiva",
    "website": "https://nextiva.com",
    "description": "VoIP and business communication platform offering services such as phone systems, team messaging, and AI answering service.",
    "color": "#0445A5",
    "categories": [
      "Collaboration & Productivity",
      "Customer Service",
      "IT Infrastructure",
      "B2B Marketplaces",
      "IT Management"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 2673
  },
  {
    "name": "Later",
    "slug": "later",
    "website": "https://www.later.com",
    "description": "Social media scheduling and marketing platform that helps businesses plan and automate posts across Instagram, Facebook, Twitter, and Pinterest.",
    "color": "#5124C1",
    "categories": [
      "Marketing",
      "Social Media",
      "Digital Advertising",
      "Content Management",
      "Analytics"
    ],
    "promotions": [],
    "popularity": 2670
  },
  {
    "name": "Capsule and Transpond",
    "slug": "capsule",
    "website": "https://capsulecrm.com",
    "description": "CRM software designed to help businesses manage contacts, track sales, and automate key customer relationship tasks.",
    "color": "#463DFB",
    "categories": [
      "Sales",
      "Customer Service",
      "Analytics",
      "Collaboration & Productivity",
      "Marketing"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 2625
  },
  {
    "name": "ABC Trainerize",
    "slug": "trainerize",
    "website": "https://www.trainerize.com",
    "description": "Fitness business management software that helps trainers and gyms create and deliver customized training programs and manage clients.",
    "color": "#FCD13B",
    "categories": [
      "Sales",
      "Customer Service",
      "Marketing",
      "B2B Marketplaces",
      "Collaboration & Productivity"
    ],
    "promotions": [],
    "popularity": 2594
  },
  {
    "name": "Reply.io",
    "slug": "reply",
    "website": "https://reply.io",
    "description": "Sales engagement platform that automates outreach through email, calls, and social media to help sales teams book more meetings.",
    "color": "#173f35",
    "categories": [
      "Analytics",
      "Marketing",
      "Artificial Intelligence",
      "Sales"
    ],
    "promotions": [],
    "popularity": 2541
  },
  {
    "name": "ZoomInfo",
    "slug": "zoominfo",
    "website": "https://www.zoominfo.com",
    "description": "Sales and marketing intelligence platform that helps businesses find and engage with the right prospects using advanced data-driven insights.",
    "color": "#F44238",
    "categories": [
      "Marketing",
      "Analytics",
      "Sales"
    ],
    "promotions": [],
    "popularity": 2532
  },
  {
    "name": "Postscript",
    "slug": "postscript",
    "website": "https://www.postscript.io",
    "description": "SMS marketing platform designed to help e-commerce businesses engage with customers through personalized text messaging.",
    "color": "#680ED9",
    "categories": [
      "Marketing",
      "E-Commerce"
    ],
    "promotions": [],
    "popularity": 2519
  },
  {
    "name": "BidX",
    "slug": "bidxgmbh",
    "website": "https://www.bidx.io/",
    "description": "BidX is a seamless, AI-powered paid advertising platform for Amazon and Walmart sellers. It covers Sponsored Products, Display, DSP, and AMC. BidX offers best-in-class account management for clients who prefer fully managed services.",
    "color": "#13144A",
    "categories": [
      "Marketing",
      "Artificial Intelligence",
      "Digital Advertising",
      "Analytics",
      "E-Commerce"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 2511
  },
  {
    "name": "DataHawk",
    "slug": "datahawk",
    "website": "https://datahawk.co",
    "description": "DataHawk is an enterprise marketplace analytics platform for Amazon and Walmart sellers. It unifies sales, SEO, advertising, and profitability data with AI-powered insights and automated reporting to grow revenue.",
    "color": "#122c47",
    "categories": [
      "E-Commerce",
      "Marketing",
      "Artificial Intelligence",
      "Commerce",
      "Vertical Industry Software"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 2476
  },
  {
    "name": "FreshBooks",
    "slug": "freshbooksusa",
    "website": "https://www.freshbooks.com/",
    "description": "FreshBooks is business management software purpose-built for service-based solopreneurs and small teams. It simplifies the financial side of running a business, so owners spend less time on admin and feel more confident about their finances.",
    "color": "#287BD1",
    "categories": [
      "Payroll",
      "B2B Marketplaces"
    ],
    "promotions": [],
    "popularity": 2454
  },
  {
    "name": "Motive",
    "slug": "motive",
    "website": "https://www.gomotive.com",
    "description": "Customer feedback and engagement platform that uses automated surveys and insights to improve user experience and product development.",
    "color": "#000000",
    "categories": [
      "Other",
      "Customer Service"
    ],
    "promotions": [],
    "popularity": 2448
  },
  {
    "name": "SPS Revenue Recovery",
    "slug": "spsrevenuerecovery",
    "website": "https://spscommerce.com",
    "description": "Software suite designed to help Amazon sellers manage business operations like inventory, marketing, and analytics to optimize growth.",
    "color": "#00BEFF",
    "categories": [
      "Collaboration & Productivity",
      "ERP",
      "B2B Marketplaces",
      "Supply Chain & Logistics",
      "Commerce"
    ],
    "promotions": [],
    "popularity": 2417
  },
  {
    "name": "CrankWheel",
    "slug": "crankwheel",
    "website": "https://crankwheel.com/",
    "description": "Sales engagement tool designed for customer-facing teams to share screens, demo products, and close deals quickly.",
    "color": "#FAB33F",
    "categories": [
      "Collaboration & Productivity",
      "Sales",
      "Marketing"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 2416
  },
  {
    "name": "SimpleTexting",
    "slug": "simpletexting",
    "website": "https://simpletexting.com/",
    "description": "SMS marketing platform that helps businesses create and send text message campaigns, automating customer interactions and engagement.",
    "color": "#0067FF",
    "categories": [
      "Marketing"
    ],
    "promotions": [],
    "popularity": 2407
  },
  {
    "name": "Buddy Punch",
    "slug": "buddypunch",
    "website": "https://buddypunch.com/",
    "description": "Buddy Punch is an online time clock that takes the hassle out of employee time tracking.",
    "color": "#364150",
    "categories": [
      "Collaboration & Productivity",
      "HR",
      "HR Software"
    ],
    "promotions": [],
    "popularity": 2365
  },
  {
    "name": "Optery",
    "slug": "optery",
    "website": "https://www.optery.com/",
    "description": "Optery helps businesses protect its employees' personal data by automatically removing it from hundreds of data broker websites, reducing security risks, phishing exposure, and compliance gaps.",
    "color": "#4676FD",
    "categories": [
      "Security",
      "Data Privacy"
    ],
    "promotions": [],
    "popularity": 2351
  },
  {
    "name": "Papaya Global",
    "slug": "papayaglobal",
    "website": "https://papayaglobal.com",
    "description": "Global payroll and workforce management platform designed to simplify payroll processing and compliance across multiple countries.",
    "color": "#FF3924",
    "categories": [
      "HR",
      "ERP",
      "B2B Marketplaces",
      "HR Software",
      "Payroll"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 2344
  },
  {
    "name": "TRUCKSTOP",
    "slug": "truckstop",
    "website": "https://www.truckstop.com",
    "description": "Freight management platform that helps logistics and transportation businesses streamline operations and find loads.",
    "color": "#D93725",
    "categories": [
      "Other",
      "Collaboration & Productivity",
      "Supply Chain & Logistics",
      "B2B Marketplaces"
    ],
    "promotions": [],
    "popularity": 2307
  },
  {
    "name": "Drip",
    "slug": "drip",
    "website": "https://www.drip.com/",
    "description": "Email marketing automation tool designed to help online stores and brands build customer relationships and drive sales through personalized campaigns.",
    "color": "#f700ff",
    "categories": [
      "Marketing"
    ],
    "promotions": [],
    "popularity": 2298
  },
  {
    "name": "CloudTask",
    "slug": "cloudtask",
    "website": "https://cloudtask.com",
    "description": "US companies use CloudTask to hire sales, marketing, customer success, and customer support professionals based in Latin America. These are the roles that drive revenue, build pipelines, retain customers, and deliver exceptional service.",
    "color": "#3368DD",
    "categories": [
      "Sales",
      "Office Software",
      "Customer Service",
      "Vertical Industry Software"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 2271
  },
  {
    "name": "VWO",
    "slug": "vwo",
    "website": "https://www.vwo.com",
    "description": "Conversion optimization platform that helps businesses improve website performance with A/B testing and analytics.",
    "color": "#E40474",
    "categories": [
      "B2B Marketplaces",
      "Marketing",
      "Collaboration & Productivity",
      "Analytics",
      "Development"
    ],
    "promotions": [],
    "popularity": 2253
  },
  {
    "name": "Unitel Voice",
    "slug": "unitelvoice",
    "website": "https://www.unitelvoice.com",
    "description": "VoIP communications platform for businesses to manage voice calls and messages.",
    "color": "#3955ff",
    "categories": [
      "Other",
      "Customer Service"
    ],
    "promotions": [],
    "popularity": 2239
  },
  {
    "name": "SmartSuite",
    "slug": "smartsuite",
    "website": "https://smartsuite.com",
    "description": "Work management platform offering customizable tools for project tracking, document management, and team collaboration.",
    "color": "#1a2943",
    "categories": [
      "Collaboration & Productivity"
    ],
    "promotions": [],
    "popularity": 2163
  },
  {
    "name": "Bolt for Business",
    "slug": "bolt",
    "website": "https://business.bolt.eu/",
    "description": "Bolt for Business simplifies company travel - managing rides, car sharing, and micromobility in one place with automated billing and reports, powered by 4M+ driver network from Bolt.",
    "color": "#2A9C64",
    "categories": [
      "Office Software",
      "HR",
      "Accounting",
      "Collaboration & Productivity",
      "Governance, Risk, & Compliance"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 2083
  },
  {
    "name": "Browse AI",
    "slug": "browseai",
    "website": "https://www.browse.ai",
    "description": "AI-based web scraping and data extraction platform for automating data collection from websites.",
    "color": "#5d3aba",
    "categories": [
      "Marketing",
      "Collaboration & Productivity",
      "Sales",
      "Artificial Intelligence",
      "IT Infrastructure"
    ],
    "promotions": [],
    "popularity": 2075
  },
  {
    "name": "Bïrch (Formerly Revealbot)",
    "slug": "reveal",
    "website": "https://bir.ch/",
    "description": "Marketing automation and analytics platform, focused on ad campaign optimization.",
    "color": "#DEDEDE",
    "categories": [
      "Social Media",
      "Marketing"
    ],
    "promotions": [],
    "popularity": 2062
  },
  {
    "name": "Synder",
    "slug": "synder",
    "website": "https://synder.com",
    "description": "Accounting automation software that integrates with business platforms to track and reconcile financial data.",
    "color": "#2993ec",
    "categories": [
      "Commerce",
      "Artificial Intelligence",
      "Accounting"
    ],
    "promotions": [],
    "popularity": 2018
  },
  {
    "name": "doola",
    "slug": "doola",
    "website": "https://www.doola.com",
    "description": "Service that helps entrepreneurs quickly form a U.S. LLC, offering tools for legal paperwork and tax compliance.",
    "color": "#EAB84D",
    "categories": [
      "Other",
      "Office Software",
      "Marketing",
      "Governance, Risk, & Compliance",
      "B2B Marketplaces"
    ],
    "promotions": [],
    "popularity": 2010
  },
  {
    "name": "Campaigner",
    "slug": "campaigner",
    "website": "https://www.campaigner.com/",
    "description": "Email marketing platform offering automation, segmentation, and analytics to help businesses engage customers effectively.",
    "color": "#1269E0",
    "categories": [
      "Other",
      "Marketing",
      "B2B Marketplaces",
      "Digital Advertising",
      "Commerce"
    ],
    "promotions": [],
    "popularity": 1979
  },
  {
    "name": "Expertise AI",
    "slug": "expertiseai",
    "website": "https://expertise.ai",
    "description": "AI agents for websites that automatically talk to visitors and turn them into sales leads!",
    "color": "#044339",
    "categories": [
      "Artificial Intelligence",
      "Sales"
    ],
    "promotions": [],
    "popularity": 1973
  },
  {
    "name": "Tapstitch",
    "slug": "tapstitch",
    "website": "https://tapstitch.com",
    "description": "Tapstitch is a fashion-on-demand platform that helps businesses, brands, and entrepreneurs create and sell premium apparel without inventory or minimums- with fast global fulfillment and high-quality production",
    "color": "#8b7ee4",
    "categories": [
      "Marketing",
      "Commerce",
      "Supply Chain & Logistics",
      "Design",
      "E-Commerce"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 1924
  },
  {
    "name": "Amplemarket",
    "slug": "amplemarket",
    "website": "https://www.amplemarket.com",
    "description": "Sales automation platform that uses AI to optimize outreach and engagement, helping businesses close deals faster.",
    "color": "#111111",
    "categories": [
      "Collaboration & Productivity",
      "Marketing",
      "Sales",
      "Artificial Intelligence"
    ],
    "promotions": [],
    "popularity": 1916
  },
  {
    "name": "Wrike",
    "slug": "wrike3742",
    "website": "https://www.wrike.com",
    "description": "Collaborative work management platform that helps teams plan, track, and deliver projects on time.",
    "color": "#08CF65",
    "categories": [
      "Vertical Industry Software",
      "Office Software",
      "Digital Advertising",
      "Collaboration & Productivity",
      "Design"
    ],
    "promotions": [],
    "popularity": 1914
  },
  {
    "name": "Wistia",
    "slug": "wistia",
    "website": "https://www.wistia.com",
    "description": "Video hosting and analytics platform that helps businesses create, share, and measure the impact of their videos.",
    "color": "#1E64F0",
    "categories": [
      "Marketing",
      "Content Management",
      "Sales"
    ],
    "promotions": [],
    "popularity": 1912
  },
  {
    "name": "Gelato",
    "slug": "gelato",
    "website": "https://www.gelato.com",
    "description": "Global print-on-demand service enabling businesses to produce and ship custom products with no upfront inventory costs.",
    "color": "#FFE28B",
    "categories": [
      "Design",
      "Supply Chain & Logistics",
      "Office Software",
      "Vertical Industry Software",
      "Commerce"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 1890
  },
  {
    "name": "Sunsama",
    "slug": "sunsama",
    "website": "https://www.sunsama.com/",
    "description": "Daily planner assistant for professionals to plan sustainable, focused, calm workdays.",
    "color": "#F4874C",
    "categories": [
      "Collaboration & Productivity",
      "HR",
      "Office Software"
    ],
    "promotions": [],
    "popularity": 1851
  },
  {
    "name": "Nexcess",
    "slug": "nexcess",
    "website": "https://www.nexcess.com",
    "description": "Managed Hosting & Bare Metal Cloud.",
    "color": "#3D7BF5",
    "categories": [
      "E-Commerce",
      "Development",
      "Governance, Risk, & Compliance",
      "Hosting Providers",
      "IT Infrastructure"
    ],
    "promotions": [],
    "popularity": 1845
  },
  {
    "name": "Format",
    "slug": "format",
    "website": "https://www.format.com",
    "description": "Website builder aimed at helping creative professionals design portfolios and personal websites with customizable templates and features.",
    "color": "#000000",
    "categories": [
      "Design"
    ],
    "promotions": [],
    "popularity": 1835
  },
  {
    "name": "Atria",
    "slug": "atria",
    "website": "https://tryatria.com",
    "description": "Atria is an AI-powered ad engine for agencies/brands, trusted by 10K+ teams. It offers tools for analytics, creation, research, asset management & inspiration—driving 10x revenue growth.",
    "color": "#F772FF",
    "categories": [
      "Content Management",
      "B2B Marketplaces",
      "Digital Advertising",
      "Marketing",
      "Analytics"
    ],
    "promotions": [],
    "popularity": 1807
  },
  {
    "name": "Kixie",
    "slug": "kixie",
    "website": "https://www.kixie.com",
    "description": "Cloud-based sales engagement platform that integrates with CRM tools to enhance team productivity and streamline outreach.",
    "color": "#FFFFFF",
    "categories": [
      "Sales"
    ],
    "promotions": [],
    "popularity": 1806
  },
  {
    "name": "Help Scout",
    "slug": "helpscout",
    "website": "https://www.helpscout.com/",
    "description": "Helpdesk software designed to improve customer support by centralizing communication, tracking inquiries, and automating responses.",
    "color": "#304DDB",
    "categories": [
      "Collaboration & Productivity",
      "Customer Service",
      "Commerce"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 1801
  },
  {
    "name": "Alohi",
    "slug": "alohi",
    "website": "http://www.alohi.com/",
    "description": "Fax.Plus and Sign.Plus make it easy to send faxes and sign documents entirely online. They serve a wide range of users, from individuals to enterprise teams, across industries where compliance and document security matter.",
    "color": "#002d32",
    "categories": [
      "Collaboration & Productivity",
      "ERP",
      "Office Software",
      "Artificial Intelligence",
      "IT Infrastructure"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 1794
  },
  {
    "name": "Quadient",
    "slug": "quadient",
    "website": "https://www.quadient.com/",
    "description": "Customer communications management platform that helps businesses streamline and automate communications across channels like print and digital.",
    "color": "#FF4200",
    "categories": [
      "Accounting"
    ],
    "promotions": [],
    "popularity": 1792
  },
  {
    "name": "Logome.ai",
    "slug": "logomeai",
    "website": "https://www.logome.ai/",
    "description": "AI-powered logo design platform that generates custom logos based on user inputs, simplifying brand creation.",
    "color": "#006AFF",
    "categories": [
      "Commerce",
      "Marketing",
      "Digital Advertising",
      "Design",
      "Artificial Intelligence"
    ],
    "promotions": [],
    "popularity": 1790
  },
  {
    "name": "Bouncer",
    "slug": "bouncer",
    "website": "https://www.usebouncer.com",
    "description": "Fraud prevention service that helps businesses verify payments and reduce chargebacks with real-time transaction analysis.",
    "color": "#2c2b76",
    "categories": [
      "Marketing",
      "E-Commerce",
      "Office Software"
    ],
    "promotions": [],
    "popularity": 1773
  },
  {
    "name": "Oyster®",
    "slug": "oyster",
    "website": "https://oysterhr.com",
    "description": "Global HR platform that helps businesses hire, onboard, and manage remote teams across various countries.",
    "color": "#000000",
    "categories": [
      "HR",
      "HR Software",
      "Governance, Risk, & Compliance"
    ],
    "promotions": [],
    "popularity": 1762
  },
  {
    "name": "SimplePractice",
    "slug": "simplepractice",
    "website": "https://www.simplepractice.com",
    "description": "Practice management software designed for healthcare providers to schedule appointments, manage patient records, and bill insurance.",
    "color": "#D3F3D9",
    "categories": [
      "Development"
    ],
    "promotions": [],
    "popularity": 1759
  },
  {
    "name": "KrispCall Communications Inc.",
    "slug": "krispcall",
    "website": "https://krispcall.com/",
    "description": "VoIP phone service that enables businesses to manage calls, track communications, and improve customer engagement.",
    "color": "#A542EB",
    "categories": [
      "Marketing",
      "B2B Marketplaces",
      "HR Software",
      "Sales",
      "Digital Advertising"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 1747
  },
  {
    "name": "Gusto",
    "slug": "gusto",
    "website": "https://gusto.com/",
    "description": "HR platform that simplifies payroll, benefits administration, and compliance for small and medium businesses.",
    "color": "#F45D48",
    "categories": [
      "HR Software",
      "Governance, Risk, & Compliance",
      "B2B Marketplaces",
      "Payroll",
      "HR"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 1737
  },
  {
    "name": "Toggl",
    "slug": "toggl",
    "website": "http://www.toggl.com/",
    "description": "Online time tracking and reporting software helping teams boost productivity, track billable hours, and view profits",
    "color": "#e57cd8",
    "categories": [
      "Collaboration & Productivity",
      "Analytics",
      "HR Software",
      "Office Software"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 1700
  },
  {
    "name": "Houzz Pro",
    "slug": "houzz",
    "website": "https://houzz.com/pro",
    "description": "Business management platform for home improvement professionals, offering tools for project management, invoicing, and client communication.",
    "color": "#4dbc15",
    "categories": [
      "Collaboration & Productivity",
      "Marketing"
    ],
    "promotions": [],
    "popularity": 1671
  },
  {
    "name": "Vibe",
    "slug": "vibe",
    "website": "https://www.vibe.co",
    "description": "Employee experience platform that helps businesses collect feedback, improve culture, and engage employees through surveys and insights.",
    "color": "#0F172A",
    "categories": [
      "Marketing",
      "Collaboration & Productivity"
    ],
    "promotions": [],
    "popularity": 1671
  },
  {
    "name": "Stamped",
    "slug": "stampedio",
    "website": "https://stamped.io/partner",
    "description": "Review and rating platform that helps businesses collect and display customer reviews and build trust with potential buyers.",
    "color": "#FAED99",
    "categories": [
      "Marketing",
      "E-Commerce"
    ],
    "promotions": [],
    "popularity": 1628
  },
  {
    "name": "Snapchat For Business",
    "slug": "snapchat",
    "website": "https://forbusiness.snapchat.com/",
    "description": "Helps brands reach Gen Z and Millennials with high-impact formats that drive real results",
    "color": "#FFFC00",
    "categories": [
      "Marketing",
      "Digital Advertising",
      "Sales",
      "Commerce",
      "E-Commerce"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 1605
  },
  {
    "name": "WhatConverts",
    "slug": "whatconverts",
    "website": "https://www.whatconverts.com",
    "description": "Lead tracking platform that helps businesses understand which marketing efforts generate leads and sales by tracking conversions across channels.",
    "color": "#0064FF",
    "categories": [
      "B2B Marketplaces",
      "Digital Advertising",
      "Marketing",
      "Commerce",
      "Analytics"
    ],
    "promotions": [],
    "popularity": 1589
  },
  {
    "name": "Aspire",
    "slug": "aspireapp",
    "website": "https://www.aspireapp.com",
    "description": "All-in-one Finance Platfform for Modern Businesses",
    "color": "#193557",
    "categories": [
      "E-Commerce",
      "Accounting",
      "Marketing",
      "B2B Marketplaces",
      "Sales"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 1544
  },
  {
    "name": "FullEnrich",
    "slug": "fullenrich",
    "website": "https://fullenrich.com",
    "description": "FullEnrich is the #1 B2B waterfall enrichment platform. Instead of relying on a single data source, it cascades through 20+ premium providers to find verified emails and mobile phone numbers — delivering 80%+ find rates.",
    "color": "#8539C4",
    "categories": [
      "Artificial Intelligence",
      "Sales",
      "Collaboration & Productivity",
      "IT Infrastructure",
      "Marketing"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 1518
  },
  {
    "name": "Guesty",
    "slug": "guesty",
    "website": "http://www.guesty.com/",
    "description": "With Guesty’s Affiliate Program, you can earn an additional stream of income, with up to 5K per referral Help your network of hospitality pros succeed in growing their businesses with our advanced hospitality operations platform.",
    "color": "#296D64",
    "categories": [],
    "promotions": [],
    "popularity": 1514
  },
  {
    "name": "Navan",
    "slug": "navan",
    "website": "https://navan.com",
    "description": "Travel and expense management platform that helps businesses automate bookings and control travel expenses.",
    "color": "#8b7ee4",
    "categories": [
      "B2B Marketplaces",
      "Office Software",
      "HR Software",
      "Artificial Intelligence",
      "ERP"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 1504
  },
  {
    "name": "Signable",
    "slug": "signable",
    "website": "https://www.signable.co.uk",
    "description": "Secure, reliable, efficient eSignature solution with dedicated support for clients worldwide.",
    "color": "#0095e6",
    "categories": [
      "Governance, Risk, & Compliance",
      "Vertical Industry Software",
      "Customer Service",
      "Supply Chain & Logistics",
      "Office Software"
    ],
    "promotions": [],
    "popularity": 1441
  },
  {
    "name": "Rokt Aftersell",
    "slug": "aftersellbyrokt",
    "website": "https://aftersell.com",
    "description": "Upsell tools for Shopify to unlock additional revenue boost average order value across buying journey.",
    "color": "#C20075",
    "categories": [
      "Marketing",
      "Development",
      "Sales",
      "Digital Advertising"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 1438
  },
  {
    "name": "MeetGeek",
    "slug": "meetgeek",
    "website": "https://www.meetgeek.ai",
    "description": "Meeting intelligence platform that helps businesses transcribe, summarize, and analyze meetings for actionable insights.",
    "color": "#4D2E89",
    "categories": [
      "Artificial Intelligence",
      "Collaboration & Productivity",
      "Customer Service",
      "Sales"
    ],
    "promotions": [],
    "popularity": 1435
  },
  {
    "name": "Lindy",
    "slug": "lindy",
    "website": "https://lindy.ai",
    "description": "Lindy Assistant handles email, meetings, and calendar for busy professionals over iMessage. No app to download, no learning curve.",
    "color": "#FFF2DE",
    "categories": [
      "Collaboration & Productivity",
      "Artificial Intelligence",
      "Customer Service",
      "Sales",
      "Content Management"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 1432
  },
  {
    "name": "Landingi",
    "slug": "landingi",
    "website": "https://landingi.com",
    "description": "Landing page builder that allows users to create, test, and optimize high-converting landing pages for marketing campaigns.",
    "color": "#2550aa",
    "categories": [
      "Marketing",
      "Design",
      "Artificial Intelligence",
      "Commerce",
      "Content Management"
    ],
    "promotions": [],
    "popularity": 1422
  },
  {
    "name": "Motion",
    "slug": "motion",
    "website": "https://motionapp.com/",
    "description": "Project management platform designed to help teams plan, track, and collaborate on tasks and projects more efficiently.",
    "color": "#8b7ee4",
    "categories": [
      "Collaboration & Productivity",
      "Marketing",
      "Analytics",
      "Digital Advertising",
      "Artificial Intelligence"
    ],
    "promotions": [],
    "popularity": 1389
  },
  {
    "name": "Melio",
    "slug": "melio",
    "website": "https://meliopayments.com",
    "description": "B2B payments platform that helps businesses pay and receive invoices online, streamlining accounts payable and receivable processes.",
    "color": "#7849ff",
    "categories": [
      "Accounting",
      "Payroll"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 1373
  },
  {
    "name": "Restream",
    "slug": "restream",
    "website": "https://restream.io",
    "description": "Live streaming platform that allows users to broadcast their content simultaneously to multiple platforms like YouTube, Facebook, and more.",
    "color": "#000000",
    "categories": [
      "Marketing",
      "Content Management",
      "Digital Advertising",
      "Commerce",
      "Collaboration & Productivity"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 1368
  },
  {
    "name": "Coffee and Contracts",
    "slug": "coffeeandcontracts",
    "website": "https://www.coffeecontracts.com",
    "description": "Client management platform designed for photographers and other creative professionals to streamline contracts and invoicing.",
    "color": "#DEDCCE",
    "categories": [
      "Collaboration & Productivity",
      "Sales",
      "Design",
      "Marketing"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 1316
  },
  {
    "name": "Lusha",
    "slug": "lusha",
    "website": "https://www.lusha.com",
    "description": "Sales intelligence platform that helps businesses find contact information for decision-makers and leads.",
    "color": "#863FFF",
    "categories": [
      "Development",
      "Data Privacy",
      "Artificial Intelligence",
      "Marketing",
      "Sales"
    ],
    "promotions": [],
    "popularity": 1309
  },
  {
    "name": "Getida",
    "slug": "getida",
    "website": "https://www.getida.com",
    "description": "Amazon FBA audit service that helps sellers recover lost revenue due to shipment and inventory errors by providing reimbursements.",
    "color": "#DD8B26",
    "categories": [
      "Commerce",
      "Vertical Industry Software",
      "E-Commerce"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 1257
  },
  {
    "name": "Hive",
    "slug": "hive",
    "website": "https://hive.com",
    "description": "Project and task management platform that helps teams collaborate, manage workflows, and meet deadlines.",
    "color": "#FFA762",
    "categories": [
      "Collaboration & Productivity",
      "B2B Marketplaces",
      "Office Software",
      "Digital Advertising"
    ],
    "promotions": [],
    "popularity": 1216
  },
  {
    "name": "CometChat",
    "slug": "cometchat",
    "website": "https://www.cometchat.com/",
    "description": "Messaging and video chat API and SDK that enables businesses to integrate real-time communication into their applications.",
    "color": "#6929CA",
    "categories": [
      "Collaboration & Productivity",
      "Development",
      "Customer Service"
    ],
    "promotions": [],
    "popularity": 1191
  },
  {
    "name": "Customer.io",
    "slug": "customerio",
    "website": "https://customer.io",
    "description": "AI-powered customer engagement platform designed for modern organizations to create personalized customer journeys that engage, convert, and scale, across all channels, including email, in-app, push, SMS, and webhooks.",
    "color": "#144D52",
    "categories": [
      "Customer Service",
      "Sales",
      "Marketing"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 1191
  },
  {
    "name": "SurveyMonkey",
    "slug": "surveymonkey",
    "website": "http://www.surveymonkey.com/",
    "description": "Platform to build surveys, collect responses and derive insights with flexible tools",
    "color": "#224f3c",
    "categories": [
      "Commerce",
      "HR Software",
      "Collaboration & Productivity",
      "Marketing",
      "Customer Service"
    ],
    "promotions": [],
    "popularity": 1179
  },
  {
    "name": "Netlify",
    "slug": "netlify",
    "website": "https://www.netlify.com/",
    "description": "Over 11 million users rely on Netlify to build and host custom websites, apps, prototypes, and internal tools. Create with AI or code, publish and share in seconds. Trusted by millions of businesses and brands like Meta, Figma, Autodesk, and Mattel.",
    "color": "#00C7B7",
    "categories": [
      "Data Privacy",
      "Development",
      "Hosting Providers",
      "Content Management",
      "HR Software"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 1176
  },
  {
    "name": "Carepatron",
    "slug": "carepatron",
    "website": "https://carepatron.com",
    "description": "Practice management software for healthcare providers, focusing on organization and patient engagement.",
    "color": "#7242ee",
    "categories": [
      "Customer Service",
      "Collaboration & Productivity"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 1173
  },
  {
    "name": "Ruby",
    "slug": "ruby",
    "website": "https://www.ruby.com",
    "description": "Virtual receptionist service offering live call answering, customer support, and lead capturing for businesses.",
    "color": "#1B264E",
    "categories": [
      "Collaboration & Productivity",
      "Customer Service"
    ],
    "promotions": [],
    "popularity": 1145
  },
  {
    "name": "Plesk",
    "slug": "webpros",
    "website": "https://www.plesk.com/",
    "description": "Web hosting control panel that helps businesses manage websites, domains, and applications from a single dashboard.",
    "color": "#384859",
    "categories": [
      "Development",
      "Other",
      "Artificial Intelligence",
      "IT Management",
      "Design"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 1133
  },
  {
    "name": "MRPeasy",
    "slug": "mrpeasy",
    "website": "https://www.mrpeasy.com",
    "description": "Cloud-based ERP software designed for small manufacturers, offering tools for production, inventory, and finance management",
    "color": "#4a91e9",
    "categories": [
      "E-Commerce",
      "Commerce",
      "Supply Chain & Logistics",
      "ERP",
      "Collaboration & Productivity"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 1096
  },
  {
    "name": "Textline",
    "slug": "textline",
    "website": "https://www.textline.com",
    "description": "SMS-based customer support platform that allows businesses to communicate with customers using text messaging.",
    "color": "#011EFF",
    "categories": [
      "Sales",
      "Digital Advertising",
      "HR Software",
      "Commerce",
      "Customer Service"
    ],
    "promotions": [],
    "popularity": 1054
  },
  {
    "name": "POWR, Inc.",
    "slug": "powr2155",
    "website": "https://powr.io",
    "description": "Suite of customizable tools and widgets to enhance website functionality, such as forms, pop-ups, and payment systems.",
    "color": "#3B8CFF",
    "categories": [
      "Marketing",
      "Development"
    ],
    "promotions": [],
    "popularity": 1052
  },
  {
    "name": "Pagecloud",
    "slug": "pagecloud",
    "website": "https://pagecloud.com",
    "description": "Web design platform that allows users to create and launch websites using a drag-and-drop editor with customizable templates.",
    "color": "#4F5FD0",
    "categories": [
      "Hosting Providers",
      "Commerce",
      "Marketing",
      "Design",
      "Digital Advertising"
    ],
    "promotions": [],
    "popularity": 1040
  },
  {
    "name": "Foxit",
    "slug": "foxit",
    "website": "https://www.foxit.com",
    "description": "PDF software solution that provides tools for creating, editing, and managing PDF documents in a collaborative environment.",
    "color": "#F68B1F",
    "categories": [
      "Office Software",
      "Collaboration & Productivity",
      "Governance, Risk, & Compliance",
      "Artificial Intelligence",
      "Data Privacy"
    ],
    "promotions": [],
    "popularity": 1038
  },
  {
    "name": "ShipBob",
    "slug": "shipbobinc",
    "website": "https://www.shipbob.com",
    "description": "E-commerce fulfillment platform that helps businesses manage inventory, pack, and ship orders to customers efficiently.",
    "color": "#175CFF",
    "categories": [
      "Commerce",
      "Supply Chain & Logistics",
      "E-Commerce",
      "Other"
    ],
    "promotions": [],
    "popularity": 1032
  },
  {
    "name": "Kisi",
    "slug": "kisi",
    "website": "http://www.getkisi.com/",
    "description": "Cloud-based access control system that replaces traditional locks with mobile and credential-based entry.",
    "color": "#4357FF",
    "categories": [
      "Office Software",
      "Other"
    ],
    "promotions": [],
    "popularity": 1032
  },
  {
    "name": "Qoyod",
    "slug": "qoyod",
    "website": "https://www.qoyod.com",
    "description": "Don’t let financial complexities hinder your business growth. Qoyod is designed to be your ultimate financial co-pilot, navigating the complexities of your business efficiency.",
    "color": "#121755",
    "categories": [
      "Accounting",
      "Office Software"
    ],
    "promotions": [],
    "popularity": 1028
  },
  {
    "name": "iContact",
    "slug": "icontact",
    "website": "https://www.icontact.com",
    "description": "Email marketing platform that helps businesses create, send, and track email campaigns to engage customers and drive sales.",
    "color": "#214AAA",
    "categories": [
      "Marketing",
      "Sales",
      "Commerce",
      "Digital Advertising",
      "B2B Marketplaces"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 1027
  },
  {
    "name": "SMTP.com",
    "slug": "smtp",
    "website": "https://www.smtp.com/",
    "description": "Email delivery platform that helps businesses send bulk emails with high deliverability and tracking capabilities.",
    "color": "#21B193",
    "categories": [
      "Digital Advertising",
      "Marketing",
      "Commerce",
      "Office Software",
      "B2B Marketplaces"
    ],
    "promotions": [],
    "popularity": 1023
  },
  {
    "name": "Closely",
    "slug": "closely",
    "website": "https://closelyhq.com/",
    "description": "Sales engagement platform that helps businesses automate outreach, track communication, and manage leads.",
    "color": "#A771FE",
    "categories": [
      "Marketing",
      "Sales",
      "Artificial Intelligence"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 1016
  },
  {
    "name": "Amplitude",
    "slug": "amplitude",
    "website": "https://www.amplitude.com",
    "description": "Product analytics platform that helps businesses track user behavior, measure engagement, and optimize growth.",
    "color": "#1e61f0",
    "categories": [
      "Artificial Intelligence",
      "Marketing",
      "Analytics",
      "Development",
      "B2B Marketplaces"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 1013
  },
  {
    "name": "Hubstaff",
    "slug": "hubstaff9986",
    "website": "https://www.hubstaff.com",
    "description": "Hubstaff provides robust time tracking software, project management tools, and workforce analytics designed to increase productivity and operational efficiency for businesses of all sizes around the world.",
    "color": "#294DFF",
    "categories": [
      "Collaboration & Productivity",
      "B2B Marketplaces",
      "Digital Advertising",
      "HR Software",
      "HR"
    ],
    "promotions": [],
    "popularity": 1012
  },
  {
    "name": "Shore",
    "slug": "shore",
    "website": "https://www.shore.com",
    "description": "Platform designed for service-based businesses, helping them manage appointments, bookings, and customer relationships.",
    "color": "#FFFFFF",
    "categories": [
      "Sales",
      "Marketing",
      "Analytics",
      "Commerce",
      "Collaboration & Productivity"
    ],
    "promotions": [],
    "popularity": 1005
  },
  {
    "name": "Really Good Emails (RGE Studio)",
    "slug": "beefree",
    "website": "https://reallygoodemails.com/studio",
    "description": "Email design platform that allows users to create responsive and professional email templates with a drag-and-drop editor.",
    "color": "#FF4C44",
    "categories": [
      "HR Software",
      "Design",
      "Collaboration & Productivity",
      "Commerce",
      "Digital Advertising"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 980
  },
  {
    "name": "RocketReach LLC",
    "slug": "rocketreachllc",
    "website": "https://rocketreach.co",
    "description": "Professional networking tool that provides contact information for individuals and companies, focusing on email outreach.",
    "color": "#00b3ff",
    "categories": [
      "Marketing",
      "Office Software",
      "Collaboration & Productivity",
      "Sales"
    ],
    "promotions": [],
    "popularity": 943
  },
  {
    "name": "Boulevard",
    "slug": "boulevard",
    "website": "https://www.joinblvd.com",
    "description": "Client experience platform for streamlining bookings, optimizing schedules, driving growth.",
    "color": "#000000",
    "categories": [
      "B2B Marketplaces",
      "Office Software",
      "Vertical Industry Software",
      "Collaboration & Productivity",
      "Marketing"
    ],
    "promotions": [],
    "popularity": 931
  },
  {
    "name": "Envoy",
    "slug": "envoy",
    "website": "https://www.envoy.com",
    "description": "We protect the places the world relies on most by uniting people, spaces, and communications on one workplace management platform, built for modern security and compliance.",
    "color": "#FA4338",
    "categories": [
      "Office Software",
      "Security"
    ],
    "promotions": [],
    "popularity": 924
  },
  {
    "name": "Brevo PushOwl",
    "slug": "pushowl",
    "website": "https://www.pushowl.com",
    "description": "Web push notification tool to help eCommerce businesses engage with customers.",
    "color": "#FD3363",
    "categories": [
      "Marketing",
      "Commerce",
      "Digital Advertising",
      "Sales",
      "E-Commerce"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 922
  },
  {
    "name": "Cognism",
    "slug": "cognism",
    "website": "https://cognism.com/",
    "description": "B2B lead generation platform that uses AI to help sales teams identify and engage with potential customers through various data sources.",
    "color": "#25204d",
    "categories": [
      "Sales"
    ],
    "promotions": [],
    "popularity": 916
  },
  {
    "name": "Shade",
    "slug": "shade",
    "website": "https://shade.inc",
    "description": "Shade is an intelligent cloud storage platform that transforms post-production workflows by replacing four to five separate tools with a single unified system for storage, asset management, review, and delivery.",
    "color": "#A900FF",
    "categories": [
      "Digital Advertising",
      "Sales",
      "Artificial Intelligence",
      "B2B Marketplaces",
      "Design"
    ],
    "promotions": [],
    "popularity": 914
  },
  {
    "name": "SMTP2GO",
    "slug": "smtp2go",
    "website": "https://www.smtp2go.com",
    "description": "Email delivery service that helps businesses send transactional emails, ensuring high deliverability and detailed reporting.",
    "color": "#00b3ff",
    "categories": [
      "Hosting Providers",
      "Commerce",
      "B2B Marketplaces",
      "IT Infrastructure",
      "Marketing"
    ],
    "promotions": [],
    "popularity": 914
  },
  {
    "name": "Uniqode",
    "slug": "uniqode",
    "website": "https://www.uniqode.com/",
    "description": "Uniqode is a QR Code generator for businesses. Create, customize, and manage dynamic QR Codes with built-in tracking and enterprise-grade security.",
    "color": "#000000",
    "categories": [
      "Development",
      "Collaboration & Productivity",
      "Content Management",
      "Commerce",
      "Digital Advertising"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 911
  },
  {
    "name": "Marketing 360®",
    "slug": "marketing360",
    "website": "https://www.marketing360.com/",
    "description": "Marketing 360® delivers an all-in-one platform for digital marketing and marketing services to help small businesses grow their brand. Trusted by over 15,000 SMBs, we are excited to work with you to help small businesses grow and local communities glow!",
    "color": "#006dd0",
    "categories": [
      "Marketing",
      "Sales",
      "Office Software",
      "Artificial Intelligence",
      "Digital Advertising"
    ],
    "promotions": [],
    "popularity": 906
  },
  {
    "name": "Increff",
    "slug": "increff",
    "website": "https://www.increff.com/",
    "description": "Cloud-based WMS merchandising solutions for fashion D2C brands to optimize inventory.",
    "color": "#F8485C",
    "categories": [
      "Other",
      "Sales",
      "Supply Chain & Logistics",
      "B2B Marketplaces",
      "IT Management"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 899
  },
  {
    "name": "Tax1099",
    "slug": "tax1099",
    "website": "https://www.tax1099.com",
    "description": "Online platform for filing 1099 tax forms, automating the process for small businesses and freelancers.",
    "color": "#0047bb",
    "categories": [
      "Accounting"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 894
  },
  {
    "name": "SleekFlow",
    "slug": "sleekflow",
    "website": "https://sleekflow.io",
    "description": "AI-powered Omnichannel Conversation Suite for seamless personal customer engagement.",
    "color": "#0D122C",
    "categories": [
      "Marketing",
      "Artificial Intelligence"
    ],
    "promotions": [],
    "popularity": 892
  },
  {
    "name": "InboxAlly",
    "slug": "inboxally",
    "website": "https://www.inboxally.com",
    "description": "Email marketing tool that focuses on enhancing deliverability and engagement through clean email list management.",
    "color": "#DDEFFF",
    "categories": [
      "Marketing",
      "Office Software",
      "B2B Marketplaces",
      "Security",
      "Digital Advertising"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 868
  },
  {
    "name": "Functional Diagnostic Nutrition",
    "slug": "afdnp",
    "website": "https://www.functionaldiagnosticnutrition.com/",
    "description": "Earn $1,000 per sign-up, plus $500 bonuses at 5 and 10 sales. Your pay grows with you! After 25 sales, your commission permanently jumps to $1,250 per sign-up, and again to $1,500 after 50. We reward loyalty and success.",
    "color": "#265683",
    "categories": [
      "Customer Service",
      "Other",
      "Collaboration & Productivity",
      "Digital Advertising",
      "Sales"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 823
  },
  {
    "name": "BugHerd",
    "slug": "bugherd",
    "website": "https://bugherd.com/",
    "description": "Visual bug tracking and project management tool that helps teams identify, manage, and resolve issues during development.",
    "color": "#E0F0F9",
    "categories": [
      "Development",
      "Collaboration & Productivity",
      "Content Management",
      "Digital Advertising",
      "Design"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 805
  },
  {
    "name": "Aura",
    "slug": "aura",
    "website": "https://goaura.com",
    "description": "Digital safety platform offering tools to protect users from identity theft, data breaches, and online scams.",
    "color": "#1a1a1a",
    "categories": [
      "Security"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 802
  },
  {
    "name": "Diginius",
    "slug": "diginiuslimited",
    "website": "https://www.diginius.com",
    "description": "Digital marketing platform offering insights and tools for managing and optimizing online advertising campaigns.",
    "color": "#FFAD00",
    "categories": [
      "Digital Advertising",
      "Marketing",
      "Sales",
      "Analytics"
    ],
    "promotions": [],
    "popularity": 800
  },
  {
    "name": "Keeper Security",
    "slug": "keepersecurity",
    "website": "https://www.keepersecurity.com",
    "description": "Password management software that securely stores and manages passwords and sensitive data for businesses and individuals.",
    "color": "#FFB900",
    "categories": [
      "Security",
      "HR Software",
      "Office Software",
      "Governance, Risk, & Compliance",
      "Data Privacy"
    ],
    "promotions": [],
    "popularity": 781
  },
  {
    "name": "Rank Prompt",
    "slug": "rankprompt",
    "website": "https://rankprompt.com",
    "description": "Platform monitoring and optimizing brand visibility across AI assistants like ChatGPT, Gemini, Claude",
    "color": "#5227B0",
    "categories": [
      "Analytics",
      "Marketing",
      "Artificial Intelligence",
      "Content Management"
    ],
    "promotions": [],
    "popularity": 773
  },
  {
    "name": "Volza",
    "slug": "volza",
    "website": "https://www.volza.com/",
    "description": "Volza is world’s most popular & global trade-intelligence platform delivering verified export-import shipment data and actionable insights. With 30 + years of heritage in trade analytics, we serve thousands of businesses and top consultancies worldwide.",
    "color": "#2E98DB",
    "categories": [
      "Sales",
      "Artificial Intelligence",
      "Office Software",
      "Marketing",
      "Data Privacy"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 769
  },
  {
    "name": "Filevine",
    "slug": "filevine",
    "website": "https://www.filevine.com/partner/partner-stack/",
    "description": "Filevine is the leading AI-first, cloud-based case and project management platform trusted by over 125,000 professionals.We help teams simplify complex workflows, improve collaboration, and drive better outcomes. While we’re built for legal organizations, any team that manages high-stakes projects can benefit from Filevine’s powerful and flexible platform.",
    "color": "#DEDEDB",
    "categories": [
      "B2B Marketplaces",
      "Governance, Risk, & Compliance",
      "Artificial Intelligence",
      "IT Management",
      "Collaboration & Productivity"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 762
  },
  {
    "name": "Runway Health",
    "slug": "runwayhealth",
    "website": "https://www.runwayhealth.com",
    "description": "Data-driven health management platform focused on helping businesses optimize healthcare operations and improve outcomes.",
    "color": "#AAC4F9",
    "categories": [
      "Other",
      "Collaboration & Productivity"
    ],
    "promotions": [],
    "popularity": 762
  },
  {
    "name": "Tenable",
    "slug": "tenable",
    "website": "https://www.tenable.com/",
    "description": "Cybersecurity platform that provides vulnerability management and threat intelligence to help businesses secure their IT environments.",
    "color": "#1E2426",
    "categories": [
      "Data Privacy",
      "IT Infrastructure",
      "B2B Marketplaces",
      "Security",
      "Artificial Intelligence"
    ],
    "promotions": [],
    "popularity": 742
  },
  {
    "name": "Time Doctor",
    "slug": "timedoctor",
    "website": "https://www.timedoctor.com",
    "description": "Time tracking and productivity software designed to monitor work habits, track billable hours, and improve team efficiency.",
    "color": "#04D464",
    "categories": [
      "Collaboration & Productivity",
      "Analytics",
      "Artificial Intelligence"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 732
  },
  {
    "name": "Runpod",
    "slug": "runpod",
    "website": "https://www.runpod.io",
    "description": "Cloud computing platform for running AI models and applications at scale.",
    "color": "#673AB7",
    "categories": [
      "Artificial Intelligence",
      "Development",
      "Collaboration & Productivity"
    ],
    "promotions": [],
    "popularity": 727
  },
  {
    "name": "WebCatalog",
    "slug": "webcataloginc",
    "website": "https://webcatalog.io",
    "description": "App converting web apps into distraction‑free desktop apps with separate project spaces",
    "color": "#2563EB",
    "categories": [
      "Collaboration & Productivity",
      "Other",
      "Office Software",
      "Development"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 709
  },
  {
    "name": "Finale Inventory",
    "slug": "finaleinventory",
    "website": "https://www.finaleinventory.com/",
    "description": "Inventory management software designed for small businesses to track products, manage orders, and forecast demand.",
    "color": "#297BBA",
    "categories": [
      "B2B Marketplaces",
      "Office Software",
      "Commerce",
      "ERP",
      "Supply Chain & Logistics"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 697
  },
  {
    "name": "8am™",
    "slug": "mycase",
    "website": "https://www.mycase.com/",
    "description": "Legal practice management software that helps law firms manage cases, clients, billing, and documents in one platform.",
    "color": "#E5F9F7",
    "categories": [
      "Vertical Industry Software",
      "Office Software",
      "Collaboration & Productivity",
      "Other"
    ],
    "promotions": [],
    "popularity": 693
  },
  {
    "name": "Miro - Affiliate",
    "slug": "miroaffiliate",
    "website": "https://www.miro.com",
    "description": "AI-powered visual workspace for brainstorming, planning, and collaboration across teams with real-time editing and 150+ integrations.",
    "color": "#FFDD33",
    "categories": [
      "HR Software",
      "Collaboration & Productivity",
      "IT Infrastructure",
      "Artificial Intelligence",
      "Design"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 693
  },
  {
    "name": "UENI.com",
    "slug": "ueniltd",
    "website": "https://ueni.com",
    "description": "Online platform offering website creation and business listing services for small businesses and local enterprises.",
    "color": "#ff4a00",
    "categories": [
      "Commerce",
      "Development",
      "Content Management",
      "Customer Service",
      "Vertical Industry Software"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 671
  },
  {
    "name": "Owner",
    "slug": "owner",
    "website": "https://www.owner.com/",
    "description": "Do you want to help local restaurants thrive in the digital age? With Owner.com, you can connect mom & pop restaurant owners to powerful online ordering and marketing tools, and earn rewards when they join our platform. Promote Owner.com through your audience, network, or client relationships, and we’ll equip you with tracking, resources, and support so you can maximize results. Together, we’ll help restaurants succeed.",
    "color": "#088924",
    "categories": [
      "B2B Marketplaces",
      "Customer Service",
      "Marketing",
      "Content Management",
      "Digital Advertising"
    ],
    "promotions": [],
    "popularity": 670
  },
  {
    "name": "EasyDMARC",
    "slug": "easydmarc",
    "website": "https://easydmarc.com#utm_source=affiliate&utm_medium=affiliate&utm_campaign=affiliate&utm_id=affiliate",
    "description": "Email security platform that protects businesses from email-based threats by managing DMARC, SPF, and DKIM records.",
    "color": "#1B2C74",
    "categories": [
      "Security",
      "Data Privacy",
      "IT Infrastructure",
      "Governance, Risk, & Compliance"
    ],
    "promotions": [],
    "popularity": 670
  },
  {
    "name": "Readymode",
    "slug": "readymode",
    "website": "https://www.readymode.com",
    "description": "Content creation platform that enables businesses to design interactive and personalized content experiences.",
    "color": "#000000",
    "categories": [
      "Marketing",
      "Sales",
      "Customer Service",
      "Collaboration & Productivity"
    ],
    "promotions": [],
    "popularity": 662
  },
  {
    "name": "Devs.ai",
    "slug": "devsai",
    "website": "https://devs.ai/home",
    "description": "Devs.ai is an enterprise-grade AI platform where teams build AI-powered business applications and deploy custom agents, with governance built in from day one.",
    "color": "#321763",
    "categories": [
      "Development",
      "Collaboration & Productivity",
      "Artificial Intelligence"
    ],
    "promotions": [],
    "popularity": 659
  },
  {
    "name": "soona",
    "slug": "soona",
    "website": "https://www.soona.co",
    "description": "On-demand video production platform that helps businesses create high-quality video content quickly and affordably.",
    "color": "#93A2F8",
    "categories": [
      "Content Management",
      "Artificial Intelligence",
      "Marketing",
      "Design",
      "Digital Advertising"
    ],
    "promotions": [],
    "popularity": 635
  },
  {
    "name": "Nutshell",
    "slug": "nutshell7477",
    "website": "https://www.nutshell.com",
    "description": "CRM software for sales, marketing, engagement that tells teams what’s next in sales cycle.",
    "color": "#FE5800",
    "categories": [
      "Artificial Intelligence",
      "Customer Service",
      "Marketing",
      "Collaboration & Productivity",
      "Sales"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 634
  },
  {
    "name": "Contractor Foreman",
    "slug": "contractorforeman",
    "website": "https://contractorforeman.com",
    "description": "SaaS solution for construction pros that redefines project management.",
    "color": "#7EAEF6",
    "categories": [
      "B2B Marketplaces",
      "Vertical Industry Software",
      "Sales",
      "Collaboration & Productivity",
      "Office Software"
    ],
    "promotions": [],
    "popularity": 633
  },
  {
    "name": "Zonka Feedback",
    "slug": "zonkafeedback",
    "website": "https://www.zonkafeedback.com",
    "description": "Customer feedback and survey tool for collecting real-time insights to improve customer experience and satisfaction.",
    "color": "#2cc4f2",
    "categories": [
      "HR Software",
      "B2B Marketplaces",
      "Collaboration & Productivity",
      "Customer Service",
      "Artificial Intelligence"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 629
  },
  {
    "name": "Calilio",
    "slug": "calilio",
    "website": "https://calilio.com",
    "description": "Calilio is an AI-powered phone system and cloud call center solution built for growing businesses. It helps manage calls, messages, and customer conversations from one simple platform. With innovative AI features, users can respond faster, work better, and understand every interaction clearly. The cloud telephony platform also offers affordable virtual phone numbers from over 100 countries, including local, mobile, and toll-free. This lets anyone build a local presence anywhere in the world.",
    "color": "#003399",
    "categories": [
      "ERP",
      "HR Software",
      "IT Management",
      "Collaboration & Productivity",
      "Sales"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 623
  },
  {
    "name": "Zypper",
    "slug": "refreshme",
    "website": "https://zypper.com",
    "description": "Zypper is a personal financial management platform.",
    "color": "#26b5aa",
    "categories": [
      "Artificial Intelligence",
      "Collaboration & Productivity",
      "Accounting"
    ],
    "promotions": [],
    "popularity": 614
  },
  {
    "name": "SalesRabbit",
    "slug": "salesrabbit",
    "website": "https://salesrabbit.com/",
    "description": "Sales management software that helps field sales teams track leads, automate reporting, and improve productivity.",
    "color": "#FE0600",
    "categories": [
      "Analytics",
      "Vertical Industry Software",
      "Sales",
      "Artificial Intelligence",
      "Marketing"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 614
  },
  {
    "name": "Iconosquare",
    "slug": "iconosquare",
    "website": "https://www.iconosquare.com/",
    "description": "Platform for effortless Social Media Management, trusted by over 10,000 brands agencies.",
    "color": "#0089FF",
    "categories": [
      "Social Media",
      "Marketing",
      "Collaboration & Productivity",
      "Artificial Intelligence",
      "Analytics"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 603
  },
  {
    "name": "Healthie",
    "slug": "healthie",
    "website": "https://www.gethealthie.com",
    "description": "EMR, Scheduling, Client Engagement platform for modern healthcare delivery.",
    "color": "#8b7ee4",
    "categories": [],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 598
  },
  {
    "name": "Sender",
    "slug": "sendernet",
    "website": "https://www.sender.net",
    "description": "All-in-one email and SMS marketing platform built for businesses that want powerful automation without complexity or high costs.",
    "color": "#F75B11",
    "categories": [
      "Commerce",
      "Design",
      "Collaboration & Productivity",
      "Analytics",
      "Marketing"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 597
  },
  {
    "name": "Blinq",
    "slug": "blinq",
    "website": "https://blinq.me",
    "description": "Blinq is a digital business card and lead capture platform that transforms professional networking and maximises the value of in-person connections.",
    "color": "#FF6552",
    "categories": [
      "Other",
      "HR",
      "Office Software",
      "Marketing",
      "Sales"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 594
  },
  {
    "name": "Vista Social",
    "slug": "vistasocial",
    "website": "https://vistasocial.com",
    "description": "We're the all-in-one social media management platform designed to deliver unbeatable value to marketing agencies, freelancers, and social media managers.",
    "color": "#A6C7F5",
    "categories": [
      "Marketing",
      "Other",
      "Artificial Intelligence",
      "Content Management",
      "Social Media"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 574
  },
  {
    "name": "Sovos Brands: TINCheck, 1099PRO, eFileMyForms & ReportMyUP",
    "slug": "sovos",
    "website": "https://promo.sovos.com/joinsovosbrands/",
    "description": "eFileMyForms and TINCheck by Sovos help businesses file accurate 1099s and W-2s with confidence. Verify TINs in real time to reduce IRS penalties, then e-file federal and state forms quickly, securely, and at scale—all in one compliance-driven workflow.",
    "color": "#00b3ff",
    "categories": [
      "B2B Marketplaces",
      "HR Software",
      "Artificial Intelligence",
      "Analytics",
      "Payroll"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 574
  },
  {
    "name": "AiSDR, Inc.",
    "slug": "aisdrinc",
    "website": "https://Aisdr.com",
    "description": "AI sales agent that automates outreach and chats with prospects via email, LinkedIn, and text in your tone.",
    "color": "#503CC7",
    "categories": [
      "Artificial Intelligence",
      "Marketing",
      "Sales",
      "Collaboration & Productivity"
    ],
    "promotions": [],
    "popularity": 571
  },
  {
    "name": "Heard",
    "slug": "heard",
    "website": "https://joinheard.com/",
    "description": "Heard is the only accounting platform built for mental health and wellness providers, combining bookkeeping, taxes, and payroll in one place. Providers using Heard save an average of 60 hours a year and $5,000 in taxes.",
    "color": "#226752",
    "categories": [
      "Office Software",
      "Accounting",
      "Collaboration & Productivity",
      "Payroll"
    ],
    "promotions": [],
    "popularity": 567
  },
  {
    "name": "Shoeboxed",
    "slug": "shoeboxedinc",
    "website": "https://www.shoeboxed.com",
    "description": "Receipt scanning and expense tracking tool that helps businesses organize and manage receipts and financial documents.",
    "color": "#00BAEC",
    "categories": [
      "Collaboration & Productivity",
      "Commerce",
      "Office Software",
      "Analytics",
      "B2B Marketplaces"
    ],
    "promotions": [],
    "popularity": 566
  },
  {
    "name": "Getscreen.me",
    "slug": "getscreenme",
    "website": "https://getscreen.me",
    "description": "Remote desktop and screen-sharing tool for team collaboration.",
    "color": "#538BFF",
    "categories": [
      "Office Software",
      "IoT Management",
      "Customer Service",
      "IT Management",
      "Collaboration & Productivity"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 563
  },
  {
    "name": "Tie (previously Revenue Roll)",
    "slug": "revenueroll",
    "website": "https://www.meettie.com",
    "description": "Marketing and sales automation platform that helps businesses track leads, automate workflows, and optimize revenue generation.",
    "color": "#1e00d6",
    "categories": [
      "Analytics",
      "Sales",
      "Commerce",
      "Marketing"
    ],
    "promotions": [],
    "popularity": 556
  },
  {
    "name": "Storylane",
    "slug": "storylane",
    "website": "https://www.storylane.io",
    "description": "Content creation tool that enables businesses to build and share interactive, immersive product demos.",
    "color": "#E0007A",
    "categories": [
      "B2B Marketplaces",
      "Sales",
      "Collaboration & Productivity",
      "Content Management",
      "Marketing"
    ],
    "promotions": [],
    "popularity": 553
  },
  {
    "name": "Top Echelon Software",
    "slug": "topechelonsoftware",
    "website": "https://www.topechelon.com",
    "description": "Recruiting software platform that streamlines the hiring process with tools for job posting, applicant tracking, and workflow automation.",
    "color": "#252a6e",
    "categories": [
      "HR",
      "Office Software",
      "HR Software"
    ],
    "promotions": [],
    "popularity": 552
  },
  {
    "name": "R.E. Cost Seg",
    "slug": "recostseg",
    "website": "https://www.recostseg.com/",
    "description": "Cost segregation studies helping property owners accelerate depreciation reduce tax burdens.",
    "color": "#15517C",
    "categories": [
      "Sales",
      "Commerce",
      "Vertical Industry Software",
      "Governance, Risk, & Compliance",
      "Accounting"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 547
  },
  {
    "name": "Prezi",
    "slug": "prezi",
    "website": "https://www.prezi.com/",
    "description": "Prezi is an AI presentation tool that helps you stand out, bring your ideas to life, and create interactive presentations easier than ever.",
    "color": "#3181ff",
    "categories": [
      "Office Software",
      "Collaboration & Productivity",
      "Artificial Intelligence",
      "Design"
    ],
    "promotions": [],
    "popularity": 545
  },
  {
    "name": "Weave Communications Inc.",
    "slug": "weavecommunicationsinc",
    "website": "https://www.getweave.com",
    "description": "All-in-one communications platform for texting, phone, scheduling, payments.",
    "color": "#0a473d",
    "categories": [
      "Analytics",
      "Collaboration & Productivity",
      "Office Software",
      "Vertical Industry Software",
      "Artificial Intelligence"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 538
  },
  {
    "name": "Survicate",
    "slug": "survicate4293",
    "website": "https://www.survicate.com",
    "description": "A customer survey and feedback platform that helps businesses collect insights for improving customer experience.",
    "color": "#5F0FF5",
    "categories": [
      "Analytics",
      "Customer Service",
      "Collaboration & Productivity",
      "Commerce",
      "Marketing"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 532
  },
  {
    "name": "Databox",
    "slug": "databox",
    "website": "https://www.databox.com/",
    "description": "Databox makes BI simple with 130+ integrations, instant dashboards, and no complex setup. Affiliates earn 20% comission for 12 months making Databox one of the easiest BI tools to promote. Best for SMBs, SaaS, Marketing, Agencies..",
    "color": "#712BCD",
    "categories": [
      "Analytics",
      "Artificial Intelligence",
      "Marketing",
      "Design",
      "Sales"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 531
  },
  {
    "name": "Assembly",
    "slug": "assembly",
    "website": "https://www.assembly.com",
    "description": "All-in-one platform for service businesses to manage clients, payments, files, forms & support",
    "color": "#101010",
    "categories": [
      "Sales",
      "Design",
      "Commerce",
      "Marketing",
      "Collaboration & Productivity"
    ],
    "promotions": [],
    "popularity": 520
  },
  {
    "name": "Whale",
    "slug": "usewhale",
    "website": "https://www.usewhale.io",
    "description": "SOP and process platform that helps businesses create, share, and manage internal knowledge.",
    "color": "#13C5F6",
    "categories": [
      "Collaboration & Productivity",
      "HR",
      "Content Management",
      "HR Software",
      "Artificial Intelligence"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 500
  },
  {
    "name": "The Go Game",
    "slug": "weve",
    "website": "https://thegogame.com",
    "description": "Corporate team-building platform that helps businesses engage employees through virtual and in-person interactive games.",
    "color": "#6E69D1",
    "categories": [
      "Other",
      "Collaboration & Productivity"
    ],
    "promotions": [],
    "popularity": 498
  },
  {
    "name": "Quartile",
    "slug": "quartile",
    "website": "https://www.quartile.com/",
    "description": "AI-powered advertising platform that automates PPC campaign management and optimizes ad spend for e-commerce businesses.",
    "color": "#ff9900",
    "categories": [
      "Sales",
      "Artificial Intelligence",
      "Marketing",
      "Commerce",
      "Digital Advertising"
    ],
    "promotions": [],
    "popularity": 497
  },
  {
    "name": "Paylocity",
    "slug": "paylocity",
    "website": "https://www.paylocity.com",
    "description": "Cloud-based HR and payroll software designed to simplify workforce management for small and mid-sized businesses.",
    "color": "#ed2024",
    "categories": [
      "B2B Marketplaces",
      "Office Software",
      "HR Software",
      "Payroll",
      "HR"
    ],
    "promotions": [],
    "popularity": 489
  },
  {
    "name": "Jane",
    "slug": "janesoftware",
    "website": "https://jane.app",
    "description": "Jane is a clinic management software and EMR for health and wellness providers that helps them open, run, and grow their businesses.",
    "color": "#00c1ca",
    "categories": [
      "Office Software",
      "Other",
      "Customer Service"
    ],
    "promotions": [],
    "popularity": 486
  },
  {
    "name": "ThorData",
    "slug": "thordata",
    "website": "https://www.thordata.com/?ls=MtqNdgmS&lk=partnerstack",
    "description": "Thordata is a premium data scraping tool and proxy IP provider, providing rotating residential IP, static ISP, mobile proxy IP, and serp api. The connection rate is 99.99%, and 24-hour customer service support is provided.",
    "color": "#1BC7B1",
    "categories": [
      "Vertical Industry Software",
      "Content Management",
      "Marketing",
      "Data Privacy",
      "IT Management"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 482
  },
  {
    "name": "Jibble",
    "slug": "jibblegroup",
    "website": "https://www.jibble.io",
    "description": "Tool tracking team hours and attendance with reporting for payroll and analytics",
    "color": "#FF6A00",
    "categories": [
      "HR Software",
      "Office Software",
      "Customer Service"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 481
  },
  {
    "name": "Bookyourdata",
    "slug": "bookyourdata1288",
    "website": "https://www.bookyourdata.com",
    "description": "A platform for purchasing and downloading business contact data to support lead generation efforts.",
    "color": "#0057FF",
    "categories": [
      "B2B Marketplaces",
      "IT Management",
      "Customer Service",
      "Analytics",
      "Collaboration & Productivity"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 477
  },
  {
    "name": "Airia",
    "slug": "airia",
    "website": "https://airia.com",
    "description": "Airia is a leading Enterprise AI Orchestration Platform, empowering organizations to securely build and manage AI solutions at scale.",
    "color": "#3E2BAC",
    "categories": [
      "Governance, Risk, & Compliance",
      "Security",
      "Artificial Intelligence"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 471
  },
  {
    "name": "Wing Assistant",
    "slug": "wingassistant",
    "website": "https://wingassistant.com",
    "description": "Wing Assistant is the largest provider of Virtual Assistants offering talent from across the globe. The Wing Partnership Program offers $1000-$1500 flat commission for every successful referral (i.e. paying customers) to its partners.",
    "color": "#1ea7e5",
    "categories": [
      "HR",
      "Customer Service",
      "B2B Marketplaces",
      "Sales"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 468
  },
  {
    "name": "Campaign Monitor by Marigold",
    "slug": "campaignmonitor",
    "website": "https://www.campaignmonitor.com",
    "description": "A platform that helps businesses create, segment and send personalized email and SMS campaigns",
    "color": "#7856FF",
    "categories": [
      "Marketing",
      "Other",
      "Digital Advertising",
      "Customer Service",
      "Office Software"
    ],
    "promotions": [],
    "popularity": 459
  },
  {
    "name": "Proton",
    "slug": "proton",
    "website": "https://www.proton.me/business",
    "description": "Secure email service platform with end-to-end encryption, tracker blocking, aliases, and cross-platform apps.",
    "color": "#6D4AFF",
    "categories": [
      "Office Software",
      "Security",
      "Collaboration & Productivity",
      "Data Privacy"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 458
  },
  {
    "name": "TaxCycle",
    "slug": "taxcycle",
    "website": "https://www.taxcycle.com",
    "description": "Tax preparation software for professionals in Canada, designed to simplify the process of preparing tax returns.",
    "color": "#13A0D6",
    "categories": [
      "Accounting"
    ],
    "promotions": [],
    "popularity": 448
  },
  {
    "name": "Zendesk",
    "slug": "zendesk",
    "website": "https://www.zendesk.com",
    "description": "Omnichannel service platform centralizing all customer support tools, data, integrations.",
    "color": "#16140C",
    "categories": [
      "Collaboration & Productivity",
      "Other",
      "E-Commerce",
      "HR",
      "Customer Service"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 433
  },
  {
    "name": "NinjaOne",
    "slug": "ninjaone",
    "website": "https://www.ninjaone.com",
    "description": "IT management platform for managing and automating remote IT support tasks, including monitoring and troubleshooting.",
    "color": "#002a42",
    "categories": [
      "Customer Service",
      "IoT Management",
      "IT Infrastructure",
      "IT Management",
      "Security"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 431
  },
  {
    "name": "Every",
    "slug": "every7437",
    "website": "https://Every.io",
    "description": "Everything founders and businesses need to launch, operate, and scale — banking, payroll, benefits, taxes, expenses and compliance. Join today and get 3 months free of HR/Payroll and Free Delaware C-Corp Formation",
    "color": "#092CA4",
    "categories": [
      "HR",
      "Payroll",
      "HR Software",
      "ERP"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 430
  },
  {
    "name": "Riverside",
    "slug": "riverside",
    "website": "https://www.riverside.com",
    "description": "Riverside is an all-in-one podcast and video studio for businesses and content creators who demand professional quality without technical complexity.",
    "color": "#383838",
    "categories": [
      "Digital Advertising",
      "Design",
      "Marketing",
      "Artificial Intelligence",
      "Office Software"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 427
  },
  {
    "name": "PitneyShip",
    "slug": "pitneybowes",
    "website": "https://www.pitneybowes.com/us",
    "description": "Shipping platform offering discounted rates, easy comparisons, streamlined label printing.",
    "color": "#009BDF",
    "categories": [
      "Commerce",
      "Customer Service",
      "Office Software",
      "IT Infrastructure",
      "Supply Chain & Logistics"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 421
  },
  {
    "name": "Pinecone",
    "slug": "pinecone",
    "website": "http://www.pinecone.io/",
    "description": "Leading vector database for building accurate, high-performance AI applications in production.",
    "color": "#171717",
    "categories": [
      "Artificial Intelligence"
    ],
    "promotions": [],
    "popularity": 419
  },
  {
    "name": "Consensus",
    "slug": "consensus",
    "website": "https://www.consensus.app",
    "description": "Consensus is an AI research tool that instantly finds and summarizes results from peer-reviewed studies. It is used by students, researchers, and clinicians to do evidence-based work faster and better.",
    "color": "#068EF1",
    "categories": [
      "Collaboration & Productivity",
      "Artificial Intelligence"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 414
  },
  {
    "name": "Office Timeline",
    "slug": "lucensoftware",
    "website": "https://officetimeline.com",
    "description": "PowerPoint add-in for creating project timelines, Gantt charts, roadmaps for professional visuals.",
    "color": "#008148",
    "categories": [
      "Office Software",
      "Collaboration & Productivity",
      "Marketing",
      "Content Management",
      "Design"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 410
  },
  {
    "name": "Aplos, Raisely & Keela",
    "slug": "aplos",
    "website": "https://www.joinvelora.com/",
    "description": "Aplos, Raisely, and Keela give nonprofits the tools to manage accounting, fundraising, and donor relationships. Aplos handles fund accounting, Raisely powers online fundraising, and Keela strengthens donor engagement. Together, these three solutions are part of the Velora integrated suite, and help nonprofits raise more, manage better, and grow their impact. Each product can also be sold separately, giving partners flexibility to meet client needs.",
    "color": "#ED88A5",
    "categories": [
      "ERP",
      "Digital Advertising",
      "Vertical Industry Software"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 408
  },
  {
    "name": "Salesmsg",
    "slug": "salesmsg",
    "website": "https://www.salesmessage.com",
    "description": "Refer the AI-powered revenue communication platform built natively for HubSpot and Salesforce. Earn 15% recurring revenue on every referral. Certified resellers earn 20% with multi-year revenue share. Co-marketing available for active partners.",
    "color": "#1D95F2",
    "categories": [
      "Sales",
      "Marketing",
      "Collaboration & Productivity",
      "Customer Service"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 406
  },
  {
    "name": "Beautiful.ai",
    "slug": "beautifulai",
    "website": "https://www.beautiful.ai/",
    "description": "Beautiful.ai is the AI presentation maker designed for professionals who need to move fast and look polished. Whether you're building a client pitch, investor deck, or internal strategy presentation, Beautiful.ai combines the speed of AI with the control",
    "color": "#00BEFF",
    "categories": [
      "Vertical Industry Software",
      "Sales",
      "Marketing",
      "Design",
      "Collaboration & Productivity"
    ],
    "promotions": [],
    "popularity": 401
  },
  {
    "name": "Zenzap",
    "slug": "zenzap",
    "website": "https://zenzap.co",
    "description": "Professional work chat app to replace WhatsApp SMS in workplace with a mobile-first design.",
    "color": "#2E81FF",
    "categories": [
      "Collaboration & Productivity",
      "Office Software",
      "Data Privacy",
      "IT Management",
      "Security"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 399
  },
  {
    "name": "IDrive",
    "slug": "idriveinc",
    "website": "https://www.idrive.com/",
    "description": "Cloud Backup for PCs, Macs, iPhones, Android other Mobile Devices into one account.",
    "color": "#004DFF",
    "categories": [
      "Data Privacy",
      "IT Management",
      "B2B Marketplaces",
      "IT Infrastructure",
      "Security"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 393
  },
  {
    "name": "Bitdefender",
    "slug": "bitdefender",
    "website": "https://www.bitdefender.com/en-us/business/campaign/ps-aff-compare-30?pid=PSAFFCOMPARE30",
    "description": "Bitdefender is a Global Leader in Cybersecurity. Enterprise-grade, multi-layered protection simplified for Small and Medium businesses. High-grade, effortless security against ransomware, phishing, and fileless attacks. This Program caters ONLY to the B2B portfolio of Bitdefender.",
    "color": "#006eff",
    "categories": [
      "IT Infrastructure",
      "B2B Marketplaces",
      "Artificial Intelligence",
      "Security",
      "Data Privacy"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 382
  },
  {
    "name": "Tradify",
    "slug": "tradify",
    "website": "https://tradifyhq.com",
    "description": "Tradify is the #1 job management software designed specifically for tradespeople. From quoting and scheduling to invoicing and payments, Tradify saves time and keeps everything in one place. Join our program today!",
    "color": "#0085FF",
    "categories": [
      "Accounting",
      "Sales",
      "Artificial Intelligence",
      "Collaboration & Productivity",
      "Office Software"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 367
  },
  {
    "name": "Kinetic Innovative Staffing",
    "slug": "kineticservicesllc",
    "website": "https://www.kineticstaff.com/p-ce/",
    "description": "Refer businesses to Kinetic Innovative Staffing and earn generous commissions. Partners get $50 per completed demo, $500 for the first referred client hire, and $100 in recurring monthly commissions per client.",
    "color": "#116AA7",
    "categories": [
      "Customer Service",
      "HR",
      "Other",
      "Digital Advertising",
      "Marketing"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 362
  },
  {
    "name": "Tresorit",
    "slug": "tresorit",
    "website": "https://www.tresorit.com",
    "description": "Cloud storage solution focused on privacy and security, offering encrypted file-sharing for businesses and teams.",
    "color": "#00A9E2",
    "categories": [
      "Governance, Risk, & Compliance",
      "IT Management",
      "Office Software",
      "Collaboration & Productivity",
      "Data Privacy"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 361
  },
  {
    "name": "Superfiliate",
    "slug": "superfiliate",
    "website": "https://superfiliate.com",
    "description": "Superfiliate is the creator-led growth platform for D2C brands focused on measurable revenue growth. Get unified affiliate and creator management, automated gifting workflows, creator storefronts, built-in discovery tooling in one place, with full visibility into which creators and programs are driving results.",
    "color": "#000000",
    "categories": [
      "E-Commerce",
      "Sales",
      "B2B Marketplaces",
      "Commerce",
      "Content Management"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 358
  },
  {
    "name": "800.com",
    "slug": "800",
    "website": "https://800.com/",
    "description": "Custom toll-free numbers for businesses to improve customer engagement.",
    "color": "#00b3ff",
    "categories": [
      "Collaboration & Productivity",
      "Office Software"
    ],
    "promotions": [],
    "popularity": 354
  },
  {
    "name": "Coast",
    "slug": "coast361",
    "website": "https://coastpay.com",
    "description": "Workforce management platform that helps businesses with scheduling, time tracking, and communication for their teams.",
    "color": "#2047F4",
    "categories": [
      "Commerce",
      "B2B Marketplaces",
      "Supply Chain & Logistics",
      "Governance, Risk, & Compliance",
      "Vertical Industry Software"
    ],
    "promotions": [],
    "popularity": 353
  },
  {
    "name": "FlexiQuiz",
    "slug": "flexiquiz",
    "website": "https://www.flexiquiz.com/quiz-maker",
    "description": "Online quiz maker for creating customizable quizzes and assessments for educational, training, and business purposes.",
    "color": "#8b7ee4",
    "categories": [
      "Other",
      "Sales",
      "Marketing",
      "HR Software",
      "Office Software"
    ],
    "promotions": [],
    "popularity": 348
  },
  {
    "name": "Feedvisor",
    "slug": "feedvisor",
    "website": "https://www.feedvisor.com",
    "description": "Inventory-aware pricing optimization for private label brands sellers.",
    "color": "#00b3ff",
    "categories": [
      "Marketing",
      "Commerce",
      "Artificial Intelligence",
      "Analytics",
      "E-Commerce"
    ],
    "promotions": [],
    "popularity": 343
  },
  {
    "name": "Taxfyle",
    "slug": "taxfyle",
    "website": "https://www.taxfyle.com",
    "description": "Online platform for managing tax preparation and filing services, connecting users with certified professionals.",
    "color": "#004FB6",
    "categories": [
      "Commerce",
      "Collaboration & Productivity",
      "Governance, Risk, & Compliance",
      "Accounting"
    ],
    "promotions": [],
    "popularity": 342
  },
  {
    "name": "ZEP",
    "slug": "zep",
    "website": "https://www.zep.de/en/",
    "description": "Digital platform for automating HR processes, including payroll, time tracking, and employee management.",
    "color": "#0b8069",
    "categories": [
      "Collaboration & Productivity",
      "HR Software",
      "ERP",
      "Office Software",
      "HR"
    ],
    "promotions": [],
    "popularity": 339
  },
  {
    "name": "Passpack",
    "slug": "passpack",
    "website": "https://www.passpack.com",
    "description": "Passpack is an enterprise-grade business password manager without the complexity or cost of traditional enterprise tools.",
    "color": "#171f53",
    "categories": [
      "Development",
      "Security",
      "Office Software",
      "Collaboration & Productivity",
      "Governance, Risk, & Compliance"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 334
  },
  {
    "name": "Turbotic",
    "slug": "turbotic",
    "website": "https://turbotic.com",
    "description": "Turbotic Automation AI is a no-code platform that lets anyone build complex automations by chatting in natural language. Describe a task, and Turbotic creates the workflow—no setup, scripts, or coding.",
    "color": "#1677ff",
    "categories": [
      "Collaboration & Productivity",
      "Office Software",
      "IoT Management",
      "Marketing",
      "IT Infrastructure"
    ],
    "promotions": [],
    "popularity": 331
  },
  {
    "name": "ADP",
    "slug": "adp",
    "website": "https://www.adp.com",
    "description": "Pay your people in just minutes, with an intuitive platform. Convenient HR and hiring tools also help you grow and manage your team.",
    "color": "#D0271D",
    "categories": [
      "Payroll",
      "HR",
      "HR Software",
      "Collaboration & Productivity",
      "Office Software"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 329
  },
  {
    "name": "Success.co",
    "slug": "success",
    "website": "https://www.success.co",
    "description": "The next gen software to run EOS®: modern and fast, deeply integrated and EOS® pure. Success.co isn’t just software - it’s our mission. We’re building something enduring, for teams that are doing the same.",
    "color": "#1A1928",
    "categories": [
      "Other",
      "Collaboration & Productivity"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 316
  },
  {
    "name": "AWeber Communications",
    "slug": "aweber8982",
    "website": "https://www.aweber.com",
    "description": "Email marketing and automation tools for small businesses to grow audiences, send newsletters, and run campaigns integrated with e-commerce and CRM.",
    "color": "#246BE8",
    "categories": [
      "Sales",
      "Marketing",
      "Artificial Intelligence",
      "Commerce",
      "Customer Service"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 313
  },
  {
    "name": "Synthflow AI",
    "slug": "synthflowai",
    "website": "https://synthflow.ai",
    "description": "No-code voice AI agent platform for automating customer interactions like appointment scheduling.",
    "color": "#8b7ee4",
    "categories": [
      "Artificial Intelligence",
      "Sales",
      "Customer Service"
    ],
    "promotions": [],
    "popularity": 310
  },
  {
    "name": "INE",
    "slug": "ine",
    "website": "https://ine.com/",
    "description": "Learning platform offering training and certification resources for IT professionals and businesses.",
    "color": "#EF7D22",
    "categories": [
      "IT Infrastructure",
      "IT Management",
      "Security",
      "Other"
    ],
    "promotions": [],
    "popularity": 302
  },
  {
    "name": "Notify Me",
    "slug": "notifyme",
    "website": "https://notify-me.io/",
    "description": "All-in-one Shopify app with restock alerts, wishlists, preorders and more.",
    "color": "#1F00FF",
    "categories": [
      "E-Commerce",
      "Commerce",
      "Marketing",
      "B2B Marketplaces"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 294
  },
  {
    "name": "Employment Hero",
    "slug": "employmenthero",
    "website": "https://www.employmenthero.com",
    "description": "Platform streamlining HR, payroll, onboarding, leave & benefits with mobile access",
    "color": "#a569ff",
    "categories": [
      "HR Software",
      "Payroll",
      "HR"
    ],
    "promotions": [],
    "popularity": 294
  },
  {
    "name": "Snowfire AI",
    "slug": "snowfireai",
    "website": "https://www.snowfire.ai",
    "description": "AI decision intelligence platform fusing corporate external data for real-time personalized insights.",
    "color": "#000000",
    "categories": [
      "Analytics",
      "IT Infrastructure",
      "Vertical Industry Software",
      "Office Software",
      "Artificial Intelligence"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 294
  },
  {
    "name": "ServiceM8",
    "slug": "servicem8",
    "website": "https://www.servicem8.com",
    "description": "Job management software for small businesses in the service industry, helping with scheduling, invoicing, and job tracking.",
    "color": "#7dc836",
    "categories": [
      "Office Software",
      "Vertical Industry Software",
      "Sales",
      "Customer Service",
      "Collaboration & Productivity"
    ],
    "promotions": [],
    "popularity": 289
  },
  {
    "name": "Zeffy",
    "slug": "zeffyinc",
    "website": "https://zeffy.com",
    "description": "Zero-fee fundraising and donor management platform trusted by 50K+ nonprofits in the US, Canada, and the UK. Funded entirely by optional donor tips.",
    "color": "#09CFAF",
    "categories": [
      "E-Commerce",
      "Marketing",
      "Design",
      "Sales",
      "Digital Advertising"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 282
  },
  {
    "name": "Vida Global Inc.",
    "slug": "vidaglobal",
    "website": "https://vida.io",
    "description": "AI phone agents answering calls/texts, scheduling, taking orders, supporting SMBs",
    "color": "#0075FF",
    "categories": [
      "Artificial Intelligence",
      "Sales",
      "Customer Service",
      "Marketing",
      "Collaboration & Productivity"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 276
  },
  {
    "name": "Flatpay",
    "slug": "flatpay",
    "website": "https://flatpay.com",
    "description": "Flatpay is a modern payments and POS provider built for physical small businesses that want simple flat rates, fast daily payouts, and no hidden fees.",
    "color": "#dbe4fe",
    "categories": [
      "Supply Chain & Logistics",
      "Customer Service",
      "B2B Marketplaces",
      "Payroll"
    ],
    "promotions": [],
    "popularity": 276
  },
  {
    "name": "The Point Co.",
    "slug": "thepointco",
    "website": "https://thepointco.com/",
    "description": "Business consulting firm specializing in strategy, marketing, and operational improvements for companies.",
    "color": "#1680CB",
    "categories": [
      "Marketing",
      "Sales"
    ],
    "promotions": [],
    "popularity": 275
  },
  {
    "name": "Accelerated Growth Studio",
    "slug": "acceleratedgrowthstudio",
    "website": "https://accelerated.digital",
    "description": "We build DTC brands one click at a time with best-in-class performance strategy and social media buying.",
    "color": "#000000",
    "categories": [
      "Digital Advertising",
      "Marketing",
      "Social Media",
      "E-Commerce"
    ],
    "promotions": [],
    "popularity": 272
  },
  {
    "name": "Checkr",
    "slug": "checkr",
    "website": "http://www.checkr.com/",
    "description": "Checkr is the verification platform for life's critical decisions - hiring, approving loans, selecting a nanny, and more. Trusted by 130,000+ businesses, Checkr AI delivers clear answers about identity and background. Partners earn $150 per referral.",
    "color": "#24bfcf",
    "categories": [
      "HR Software",
      "Artificial Intelligence",
      "Governance, Risk, & Compliance",
      "HR"
    ],
    "promotions": [],
    "popularity": 269
  },
  {
    "name": "NexGen Technologies LLC",
    "slug": "nexgentechnologiesllc",
    "website": "https://www.nexgenvirtualworkplace.net/",
    "description": "Immersive virtual workplaces that foster collaboration, culture, accountability for all work environments.",
    "color": "#038B3F",
    "categories": [
      "Customer Service",
      "Collaboration & Productivity",
      "B2B Marketplaces",
      "Other"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 269
  },
  {
    "name": "Flocksy",
    "slug": "flocksy",
    "website": "https://flocksy.com",
    "description": "Flocksy gives brands instant access to a dedicated creative team for a flat rate. With 140+ services like graphic design, video editing, motion graphics, and web design, it’s the ultimate scalable creative backbone for your clients.",
    "color": "#00d28c",
    "categories": [
      "Marketing",
      "Content Management",
      "Artificial Intelligence",
      "Collaboration & Productivity",
      "Design"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 259
  },
  {
    "name": "Alvys Inc.",
    "slug": "alvysinc",
    "website": "https://alvys.com",
    "description": "Join the Alvys Partner Program! Earn rewards for referrals, integrate seamlessly with our all-in-one modern TMS, and access exclusive tools and marketplace opportunities. Open to customers, tech companies, and industry influencers.",
    "color": "#343fef",
    "categories": [
      "Vertical Industry Software",
      "Supply Chain & Logistics",
      "Other"
    ],
    "promotions": [],
    "popularity": 258
  },
  {
    "name": "Payoneer Workforce Management",
    "slug": "payoneer557",
    "website": "https://www.payoneer.com/workforce-management/",
    "description": "As a trusted publicly traded global payment and workforce management platform, we help businesses onboard, pay, and manage global teams across 160+ countries, with support to navigate local compliance.",
    "color": "#FF8C00",
    "categories": [
      "HR Software",
      "Payroll",
      "HR"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 257
  },
  {
    "name": "Pangram Labs",
    "slug": "pangramlabs",
    "website": "https://www.pangram.com",
    "description": "We are a research-backed AI detection company that helps educators, content creators, and other organizations create AI transparency for their organizations and their customers.",
    "color": "#FF6A00",
    "categories": [
      "Content Management",
      "Artificial Intelligence",
      "Governance, Risk, & Compliance",
      "Collaboration & Productivity",
      "Marketing"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 251
  },
  {
    "name": "Playroll",
    "slug": "playroll",
    "website": "http://playroll.com/",
    "description": "Playroll makes it easy for global companies to hire and pay employees or contractors in 180+ countries. We take care of employment, payroll, compliance, and localized benefits through one platform - helping your clients expand internationally without open",
    "color": "#5F17F8",
    "categories": [
      "Payroll",
      "HR Software",
      "HR"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 248
  },
  {
    "name": "Dry Ground AI",
    "slug": "drygroundai",
    "website": "https://dryground.ai",
    "description": "AI solutions engineering and research lab with two affiliate products. CompanyClaw: AI operator built on OpenClaw for businesses. Nexa: built for AI consultancies that need to scope, propose, and deliver faster.",
    "color": "#00A3E0",
    "categories": [
      "Collaboration & Productivity",
      "B2B Marketplaces",
      "Artificial Intelligence",
      "IT Management",
      "Vertical Industry Software"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 245
  },
  {
    "name": "PDWare",
    "slug": "pdware",
    "website": "https://pdware.com",
    "description": "PDWare provides Project Portfolio Management (PPM) software for businesses with a focus on Resource Management. We help companies figure out if they have the right number of people and skills to achieve their portfolio of projects, and if not, provide what-if tools and views to optimize the resources they have",
    "color": "#EE7C30",
    "categories": [
      "HR",
      "Office Software"
    ],
    "promotions": [],
    "popularity": 245
  },
  {
    "name": "Spiky.ai",
    "slug": "spiky",
    "website": "http://www.spiky.ai/",
    "description": "Spiky.ai is an AI-powered conversation intelligence platform designed to turn every meeting into a measurable impact by providing actionable insights for sales, CX, CS, HR, and PM teams.",
    "color": "#FFAC40",
    "categories": [
      "Sales",
      "Collaboration & Productivity",
      "Artificial Intelligence"
    ],
    "promotions": [],
    "popularity": 244
  },
  {
    "name": "Backlog by Nulab Inc",
    "slug": "nulab",
    "website": "https://nulab.com/backlog/",
    "description": "Backlog is the all-in-one project management platform built for teams that move fast. It helps small and mid-sized teams manage projects, track bugs, and collaborate across roles without the complexity of enterprise tools.",
    "color": "#42CE9F",
    "categories": [
      "Development",
      "Artificial Intelligence",
      "Design",
      "Marketing",
      "Collaboration & Productivity"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 235
  },
  {
    "name": "Hopp for Business",
    "slug": "hoppforbusiness",
    "website": "https://gethopp.com/en/",
    "description": "Hopp for Business is a platform for corporate ground transport connecting companies to over 4 million driver partners. We support over 60,000 businesses in more than 50 countries.",
    "color": "#2A9C64",
    "categories": [
      "Office Software",
      "HR",
      "Accounting",
      "Collaboration & Productivity",
      "B2B Marketplaces"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 232
  },
  {
    "name": "Influencer Hero",
    "slug": "influencerhero",
    "website": "https://influencer-hero.com",
    "description": "All-in-one influencer platform helping brands increase ROI, lower CAC, and drive quality UGC with AI and data",
    "color": "#EA591f",
    "categories": [
      "Digital Advertising",
      "Marketing",
      "Commerce",
      "Content Management",
      "Social Media"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 230
  },
  {
    "name": "WiseStamp",
    "slug": "wisestamp",
    "website": "https://www.wisestamp.com",
    "description": "WiseStamp is an award-winning, enterprise-grade email signature management platform designed to scale with the needs of market-leading organizations. Trusted by over 1.2 million customers worldwide, WiseStamp enables businesses to centrally create, manage, and deploy professional, on-brand email signatures effortlessly. WiseStamp turns every email into a powerful brand asset, enabling enterprises to maintain brand consistency, enhance engagement, and drive business impact at scale.",
    "color": "#111B71",
    "categories": [
      "Digital Advertising",
      "Marketing",
      "IT Management",
      "Collaboration & Productivity",
      "Design"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 229
  },
  {
    "name": "Crazy Egg",
    "slug": "crazyegg",
    "website": "https://www.crazyegg.com",
    "description": "Visual analytics tool with heatmaps, recordings, and A/B tests to optimize website conversions",
    "color": "#74B159",
    "categories": [
      "Analytics",
      "Marketing"
    ],
    "promotions": [],
    "popularity": 227
  },
  {
    "name": "Demodesk",
    "slug": "demodesk9671",
    "website": "https://demodesk.com",
    "description": "AI Agents that listen to sales conversations to automate manual work, coach sellers and generate critical insights.",
    "color": "#0049ff",
    "categories": [
      "Collaboration & Productivity",
      "Sales",
      "Analytics",
      "Office Software",
      "Customer Service"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 225
  },
  {
    "name": "ESGI Software",
    "slug": "esgisoftware",
    "website": "http://esgisoftware.com/",
    "description": "ESGI is an easy-to-use assessment tool that helps educators save time and track student progress in real time. Our affiliate program empowers partners to share ESGI, earn rewards, and support teachers with powerful tools that make a difference.",
    "color": "#1AAD29",
    "categories": [],
    "promotions": [],
    "popularity": 220
  },
  {
    "name": "Ninja Promo",
    "slug": "ninjapromo",
    "website": "https://ninjapromo.io",
    "description": "Ninja Promo is a full-service digital marketing company with subscription-based dedicated teams. Get CMO-on-demand, strategists, designers, and analysts working as one unit for predictable costs, faster execution, and in-house level impact.",
    "color": "#8b7ee4",
    "categories": [
      "Digital Advertising",
      "Design",
      "Analytics",
      "Marketing",
      "Content Management"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 219
  },
  {
    "name": "Momence",
    "slug": "momence",
    "website": "https://momence.com/",
    "description": "The #1 Vertical SaaS platform for fitness studios, gyms, spas, and dance schools. Our consolidated solution offers the best booking, reporting, marketing automation tool for both classes and appointments based experience businesses.",
    "color": "#6360E1",
    "categories": [
      "Vertical Industry Software",
      "Artificial Intelligence"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 216
  },
  {
    "name": "Adwisely",
    "slug": "adwisely",
    "website": "https://adwisely.com",
    "description": "Adwisely automates Meta and Google ad campaigns for Shopify-powered stores, improving ROAS and saving time on daily ad management.",
    "color": "#59CC49",
    "categories": [
      "Artificial Intelligence",
      "E-Commerce",
      "Marketing",
      "Social Media",
      "Sales"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 215
  },
  {
    "name": "Nickel",
    "slug": "nickeltechnologyinc",
    "website": "https://www.nickel.com",
    "description": "Nickel is the easiest way for US businesses to pay and get paid — built for America's core industries. Nickel Core is completely free, with unlimited ACH transfers, bill pay, and competitive card rates. Paid plans unlock advanced workflows.",
    "color": "#611c33",
    "categories": [
      "Commerce",
      "Vertical Industry Software",
      "B2B Marketplaces",
      "Other",
      "Accounting"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 204
  },
  {
    "name": "Prevue HR",
    "slug": "prevuehr",
    "website": "https://www.prevuehr.com",
    "description": "Talent assessment platform offering pre-employment testing, psychometric assessments, and personality evaluations.",
    "color": "#d70c7a",
    "categories": [
      "HR Software",
      "HR"
    ],
    "promotions": [],
    "popularity": 204
  },
  {
    "name": "Fireflies.ai",
    "slug": "firefliesaicorp",
    "website": "https://www.fireflies.ai",
    "description": "The #1 AI Notetaker and Assistant",
    "color": "#7A5AF8",
    "categories": [
      "Artificial Intelligence",
      "Office Software",
      "Collaboration & Productivity"
    ],
    "promotions": [],
    "popularity": 202
  },
  {
    "name": "Ultahost",
    "slug": "ultahost",
    "website": "https://ultahost.com",
    "description": "Domain registration, reliable web hosting, intuitive website building tools for an online presence.",
    "color": "#8b7ee4",
    "categories": [
      "Design",
      "IT Infrastructure",
      "Development",
      "Digital Advertising",
      "Content Management"
    ],
    "promotions": [],
    "popularity": 196
  },
  {
    "name": "ngram",
    "slug": "ngram",
    "website": "https://www.ngram.com",
    "description": "ngram is an AI Video Engine. Help Marketing and product teams create professional videos without hiring a video team. Earn up to 30% recurring commission for every customer you refer.",
    "color": "#EC6B62",
    "categories": [
      "Marketing",
      "Artificial Intelligence",
      "Content Management",
      "Sales",
      "Collaboration & Productivity"
    ],
    "promotions": [],
    "popularity": 192
  },
  {
    "name": "Cerri.com",
    "slug": "cerricomag9959",
    "website": "https://cerri.com",
    "description": "Enterprise project and portfolio management software that helps teams plan, track, and collaborate efficiently with advanced reporting, resource management, and flexible cloud or on-premise deployment.",
    "color": "#00A3FF",
    "categories": [
      "Collaboration & Productivity"
    ],
    "promotions": [],
    "popularity": 188
  },
  {
    "name": "CoRecruit (formerly Quil)",
    "slug": "quil",
    "website": "https://corecruit.com",
    "description": "CoRecruit is the #1 AI assistant for recruitment agencies. Automate busywork and save up to 8+ hours a week. CoRecruit captures every conversation across phone, VoIP, WhatsApp, Zoom, and more, then instantly updates your ATS/CRM.",
    "color": "#0e1828",
    "categories": [
      "Collaboration & Productivity",
      "Artificial Intelligence",
      "Office Software",
      "HR Software"
    ],
    "promotions": [],
    "popularity": 186
  },
  {
    "name": "Distance",
    "slug": "distance",
    "website": "https://distance.so",
    "description": "Distance is the AI Sales Platform built for service businesses. Capture more leads and book more jobs across channels 24/7.",
    "color": "#C8AD86",
    "categories": [
      "Sales",
      "Artificial Intelligence",
      "Customer Service",
      "AR/VR "
    ],
    "promotions": [],
    "popularity": 181
  },
  {
    "name": "OmniSEO",
    "slug": "omniseo",
    "website": "https://omniseo.com",
    "description": "We help marketing teams own their brand's visibility in AI search.",
    "color": "#0C57AD",
    "categories": [
      "Marketing",
      "Artificial Intelligence",
      "Analytics"
    ],
    "promotions": [],
    "popularity": 178
  },
  {
    "name": "Ten Speed",
    "slug": "tenspeed",
    "website": "https://www.tenspeed.io",
    "description": "Ten Speed is the marketing agency that drives sustainable growth for B2B brands via content marketing, SEO, GEO, email, and organic social.",
    "color": "#00d28c",
    "categories": [
      "Marketing",
      "B2B Marketplaces",
      "Analytics",
      "Artificial Intelligence",
      "Content Management"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 175
  },
  {
    "name": "Angels Partners",
    "slug": "angelspartners",
    "website": "https://angelspartners.com",
    "description": "Angels Partners helps entrepreneurs connect with relevant investors in their industry. Our mission is to help founders boost their fundraising process and schedule more meetings with targeted investors.",
    "color": "#00b3ff",
    "categories": [
      "B2B Marketplaces",
      "Collaboration & Productivity"
    ],
    "promotions": [],
    "popularity": 174
  },
  {
    "name": "Soul Link",
    "slug": "supernalworldcreations",
    "website": "https://soul-link.org",
    "description": "Platform offering tools for mental health support, wellness programs, and team engagement within organizations.",
    "color": "#4B2B5A",
    "categories": [
      "HR"
    ],
    "promotions": [],
    "popularity": 174
  },
  {
    "name": "Goflow",
    "slug": "goflow",
    "website": "https://www.goflow.com",
    "description": "Platform unifying orders, inventory, shipping and analytics for multichannel e‑commerce",
    "color": "#536dfe",
    "categories": [
      "Supply Chain & Logistics",
      "ERP",
      "Sales",
      "B2B Marketplaces",
      "Commerce"
    ],
    "promotions": [],
    "popularity": 173
  },
  {
    "name": "Velory",
    "slug": "velory",
    "website": "https://www.velory.com",
    "description": "Platform to automate and manage the entire IT asset lifecycle, from purchase to end-of-life.",
    "color": "#E7CEB5",
    "categories": [
      "IT Management",
      "Office Software"
    ],
    "promotions": [],
    "popularity": 162
  },
  {
    "name": "ElevateForward.ai",
    "slug": "elevateforwardai",
    "website": "https://elevateforward.ai",
    "description": "ElevateForward is a platform that turns business insights into clear strategy and execution. It identifies what’s slowing your business, delivers actionable plans, and helps teams drive measurable results, faster and with full visibility in one system.",
    "color": "#584DA0",
    "categories": [
      "Collaboration & Productivity",
      "Artificial Intelligence",
      "Office Software",
      "B2B Marketplaces"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 160
  },
  {
    "name": "Shiftie",
    "slug": "shiftie",
    "website": "https://shiftie.co",
    "description": "Shiftie is a smart staff scheduling and workforce management platform designed for attractions, hospitality, and leisure businesses. It helps teams create, manage, and share rotas with ease, track staff availability, manage time off, and handle clock-ins",
    "color": "#2C1841",
    "categories": [
      "HR Software",
      "Collaboration & Productivity",
      "Office Software"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 153
  },
  {
    "name": "StampEzee",
    "slug": "stampezee",
    "website": "https://www.stampezee.com",
    "description": "StampEzee is a digital stamp card loyalty & rewards platform that helps retailers create a fully branded, automated loyalty system, and build real customer loyalty leading to repeat visits and revenue growth!",
    "color": "#CF261D",
    "categories": [
      "Marketing",
      "Sales",
      "Customer Service",
      "Collaboration & Productivity",
      "Digital Advertising"
    ],
    "promotions": [],
    "popularity": 152
  },
  {
    "name": "CleverTap",
    "slug": "clevertap",
    "website": "https://www.clevertap.com",
    "description": "Create personalized experiences to retain your most valuable customers, forever, with CleverTap’s All-In-One engagement platform.",
    "color": "#FF0004",
    "categories": [
      "Development",
      "Content Management",
      "Marketing",
      "Collaboration & Productivity",
      "Sales"
    ],
    "promotions": [],
    "popularity": 151
  },
  {
    "name": "DataSnipper",
    "slug": "datasnipper",
    "website": "https://datasnipper.com",
    "description": "DataSnipper is an intelligent automation platform that automatically and securely extracts, cross-references and validates source documents of any audit and finance procedure",
    "color": "#001640",
    "categories": [
      "Governance, Risk, & Compliance",
      "Collaboration & Productivity",
      "Artificial Intelligence",
      "Accounting"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 150
  },
  {
    "name": "Vestwell",
    "slug": "vestwell",
    "website": "https://www.vestwell.com",
    "description": "Vestwell is the modern savings platform helping small and mid‑size businesses offer high‑quality, affordable retirement and workplace savings plans.",
    "color": "#024FFF",
    "categories": [
      "HR",
      "B2B Marketplaces",
      "HR Software"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 148
  },
  {
    "name": "Shopmonkey",
    "slug": "shopmonkey",
    "website": "https://www.shopmonkey.io",
    "description": "All-in-one cloud-based shop management system for organizing operating all aspects of a shop.",
    "color": "#2D3FFF",
    "categories": [],
    "promotions": [],
    "popularity": 140
  },
  {
    "name": "Bokun, a Tripadvisor company",
    "slug": "bokuntripadvisor",
    "website": "https://www.bokun.io",
    "description": "The complete booking and channel management solution for extraordinary experiences.",
    "color": "#DBFF28",
    "categories": [
      "Marketing",
      "Sales",
      "Supply Chain & Logistics",
      "B2B Marketplaces",
      "Office Software"
    ],
    "promotions": [],
    "popularity": 138
  },
  {
    "name": "Teikametrics",
    "slug": "teikametricsinc",
    "website": "https://www.teikametrics.com",
    "description": "Teikametrics is an AI-powered marketplace platform powered by Artificial Retail Intelligence (ARI) that helps brands optimize ads, listings, and inventory to drive profitable growth across Amazon, Walmart, and TikTok Shop.",
    "color": "#8C32FF",
    "categories": [
      "Artificial Intelligence",
      "Digital Advertising",
      "Marketing",
      "B2B Marketplaces",
      "Commerce"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 137
  },
  {
    "name": "Atto",
    "slug": "attospectalabsinc",
    "website": "https://attotime.com",
    "description": "AI‑powered multi‑currency accounting platform",
    "color": "#1E9CAA",
    "categories": [
      "Vertical Industry Software",
      "Office Software",
      "B2B Marketplaces",
      "HR Software",
      "Collaboration & Productivity"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 137
  },
  {
    "name": "AISQ",
    "slug": "aisq",
    "website": "https://aisq.com/meteor",
    "description": "Help agencies cut software costs and scale monthly retainers without hiring. AISQ Meteor gives them 10 elite tools in one unified stack. Built by agency vets. Powered by AI. Backed by 25K+ paying customers worldwide and 13+ years in the market.",
    "color": "#FF5A00",
    "categories": [
      "Marketing",
      "Artificial Intelligence",
      "Analytics",
      "Development",
      "Customer Service"
    ],
    "promotions": [],
    "popularity": 136
  },
  {
    "name": "WorkWise Compliance",
    "slug": "workwisecompliance",
    "website": "https://workwisecompliance.com",
    "description": "WorkWise Compliance helps employers stay compliant with labor law posting rules through easy, all-in-one solutions. Ideal partners include HR platforms, PEOs, and business consultants. Partners earn up to $1,000 in bonuses plus ongoing commission for every new customer. Simple to sell, easy to promote, and backed by 35+ years of compliance expertise.",
    "color": "#392172",
    "categories": [
      "B2B Marketplaces",
      "Hosting Providers",
      "Governance, Risk, & Compliance"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 134
  },
  {
    "name": "Engine",
    "slug": "engine",
    "website": "http://engine.com/",
    "description": "Travel management platform that simplifies and manages business and group travel.",
    "color": "#202020",
    "categories": [
      "B2B Marketplaces",
      "Supply Chain & Logistics",
      "Digital Advertising",
      "Analytics",
      "Collaboration & Productivity"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 132
  },
  {
    "name": "AI InteleKt Inc.",
    "slug": "aiintelekt",
    "website": "https://clv.aiintelekt.com",
    "description": "Our Customer Lifetime Value solution (CLV) is a solution built specifically for SMBs and mid-market brands. The dashboard reveals: * Who your client’s best customers are * How much they’re worth Customer Lifetime Value (CLV) * Where they came from — by product, channel, cohort, or campaign * What to do next to retain them No data science team needed. Just insights they can act on. Customer acquisition costs are rising. CLV is a key strategy to increase revenue.",
    "color": "#3798ff",
    "categories": [],
    "promotions": [],
    "popularity": 130
  },
  {
    "name": "AgencyAnalytics",
    "slug": "agencyanalytics",
    "website": "https://agencyanalytics.com/",
    "description": "AgencyAnalytics is a client reporting and analytics platform built for marketing agencies. It centralizes data from leading marketing tools into automated dashboards and reports that help agencies prove ROI, save time, and scale with confidence.",
    "color": "#0072ee",
    "categories": [
      "Digital Advertising",
      "Marketing",
      "Vertical Industry Software",
      "Analytics"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 129
  },
  {
    "name": "QuickSigner",
    "slug": "quicksigner",
    "website": "https://www.quicksigner.com",
    "description": "QuickSigner is the enterprise-grade, ISO 27001-certified e-signature online platform used by 30,000+ users. Unlimited AATL e-signatures on every plan, no per-envelope fees — easy to recommend, easy to convert. Earn 30% recurring commission, 90-day cookie.",
    "color": "#4193ff",
    "categories": [
      "Collaboration & Productivity",
      "Office Software"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 127
  },
  {
    "name": "TheTop",
    "slug": "thetop",
    "website": "https://thetop.com",
    "description": "TheTop is an AI powered Chief of Staff that transforms the noise of your day into one clear daily brief. It cuts through chaos, surfaces what matters most, and helps anyone start focused, confident, and in control.",
    "color": "#2E81FF",
    "categories": [
      "Office Software",
      "Collaboration & Productivity",
      "B2B Marketplaces",
      "Analytics",
      "Artificial Intelligence"
    ],
    "promotions": [],
    "popularity": 123
  },
  {
    "name": "TestGorilla",
    "slug": "testgorilla",
    "website": "https://www.testgorilla.com",
    "description": "SOURCE, SCREEN, SHORTLIST. ALL IN ONE PLACE. Partner with us and tap into the world’s largest skills‑tested talent pool, then assess any candidate with 350+ science‑backed tests, video interviews, AI scoring, and more.",
    "color": "#D410AA",
    "categories": [
      "Artificial Intelligence",
      "HR Software"
    ],
    "promotions": [],
    "popularity": 121
  },
  {
    "name": "CrowdStrike",
    "slug": "crowdstrike",
    "website": "https://www.crowdstrike.com",
    "description": "Industry leader in AI-powered cybersecurity and turn your customer relationships into revenue. CrowdStrike protects the people, processes and technologies that drive modern enterprise. A single agent solution to stop breaches, ransom",
    "color": "#EC0000",
    "categories": [
      "IT Management",
      "Artificial Intelligence",
      "Governance, Risk, & Compliance",
      "Security",
      "Data Privacy"
    ],
    "promotions": [],
    "popularity": 120
  },
  {
    "name": "Confido Health",
    "slug": "confidohealth",
    "website": "https://www.confido.health",
    "description": "Confido Health’s 24/7 healthcare-only Voice AI improves patient access—handling scheduling, insurance, outreach, follow-ups, and more—and updates EHR/PMS so staff can focus on care. Across voice, SMS, email, and web chat. Customers can go live in 30 days.",
    "color": "#17234d",
    "categories": [
      "Artificial Intelligence",
      "IT Infrastructure",
      "Vertical Industry Software",
      "IT Management",
      "Collaboration & Productivity"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 120
  },
  {
    "name": "Canvas® Score by Roya.com",
    "slug": "trialcoa9wvt6jdkasmvgroya",
    "website": "https://www.canvasscore.com/",
    "description": "*US & Canada customers only*",
    "color": "#8144f7",
    "categories": [
      "Artificial Intelligence",
      "Marketing",
      "Customer Service"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 116
  },
  {
    "name": "Evolve",
    "slug": "evolveailearning",
    "website": "https://evolveplatform.ai",
    "description": "Evolve is the AI-native, next-generation learning platform bringing the agentic AI experience to learners and L&D professionals. Convert files into interactive, ready-to-use courses in less than 24 hours. Improve learning outcomes with simulations, open-e",
    "color": "#3366FF",
    "categories": [
      "Artificial Intelligence",
      "Collaboration & Productivity"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 116
  },
  {
    "name": "Compliancely",
    "slug": "compliancely",
    "website": "https://www.compliancely.com",
    "description": "AI-powered global identity verification API for automating KYC/KYB simplifying regulatory compliance.",
    "color": "#4CC9E9",
    "categories": [],
    "promotions": [],
    "popularity": 109
  },
  {
    "name": "PartnerCentric",
    "slug": "partnercentric",
    "website": "https://www.partnercentric.com",
    "description": "PartnerCentric is a leading affiliate and partnership marketing agency that helps brands drive measurable growth through strategic, data-driven partnership programs. Using deep expertise across affiliate management, influencer collaborations, and performa",
    "color": "#44CBEA",
    "categories": [
      "Digital Advertising",
      "Marketing",
      "E-Commerce"
    ],
    "promotions": [],
    "popularity": 109
  },
  {
    "name": "InMotion Hosting",
    "slug": "inmotionhostinginc",
    "website": "https://www.inmotionhosting.com",
    "description": "Partner with InMotion Hosting to earn commissions on client referrals, offer exclusive hosting discounts, and access agency-focused support, migrations, resources, and growth opportunities.",
    "color": "#2245C4",
    "categories": [
      "Hosting Providers",
      "IT Infrastructure",
      "E-Commerce",
      "Development",
      "Design"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 108
  },
  {
    "name": "Consentz",
    "slug": "consentz",
    "website": "https://consentz.com",
    "description": "Consentz is the platform that transforms how beauty and wellness clinics operate – patient bookings, medical records, and marketing tools all in one place. Recommend something your audience will thank you for and earn up to $200 CPA per customer!",
    "color": "#F9F6E7",
    "categories": [
      "Vertical Industry Software",
      "Office Software",
      "Collaboration & Productivity",
      "Customer Service",
      "Marketing"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 104
  },
  {
    "name": "Seel",
    "slug": "seelinc",
    "website": "https://www.seel.com",
    "description": "Seel helps merchants increase conversion, protect revenue, and deliver better post-purchase experiences with embedded order protection and returns solutions, all at no cost to the brand.",
    "color": "#8b7ee4",
    "categories": [
      "B2B Marketplaces",
      "Customer Service",
      "Artificial Intelligence",
      "Commerce",
      "Governance, Risk, & Compliance"
    ],
    "promotions": [],
    "popularity": 104
  },
  {
    "name": "WestFax",
    "slug": "westfax",
    "website": "https://westfax.com",
    "description": "HIPAA-compliant cloud fax built for healthcare. WestFax offers high deliverability, real support, EHR integrations, and modern features like automated fax categorization. Affiliates earn recurring commissions by promoting a high-trust, low-churn solution.",
    "color": "#b4232d",
    "categories": [
      "IT Infrastructure",
      "IT Management",
      "Collaboration & Productivity",
      "Security",
      "Office Software"
    ],
    "promotions": [],
    "popularity": 103
  },
  {
    "name": "Claap",
    "slug": "claap",
    "website": "https://www.claap.io",
    "description": "Claap turns every sales call into pipeline intelligence. AI meeting notes, coaching insights, and async video collaboration: built for RevOps, sales enablement, and consulting partners to resell or embed.",
    "color": "#FF5A81",
    "categories": [
      "Sales",
      "Artificial Intelligence",
      "Collaboration & Productivity"
    ],
    "promotions": [],
    "popularity": 103
  },
  {
    "name": "Typewise",
    "slug": "typewiseag",
    "website": "https://typewise.app",
    "description": "AI Agent Platform for Customer Service",
    "color": "#3C61E2",
    "categories": [
      "Artificial Intelligence",
      "Commerce",
      "Customer Service",
      "Sales"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 98
  },
  {
    "name": "Rebolt",
    "slug": "rebolt",
    "website": "https://rebolthq.com",
    "description": "All-in-one marketing platform for home service businesses, offering SEO-optimized websites, social media management, and AI-powered content creation. Start changing your customers lives today by simplifying one of their biggest pain points!",
    "color": "#FF5700",
    "categories": [
      "Digital Advertising",
      "Artificial Intelligence",
      "Marketing",
      "Other"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 89
  },
  {
    "name": "HiBob Affiliate",
    "slug": "hibobaffiliate",
    "website": "https://hibob.com",
    "description": "HiBob is a modern, all-in-one HR platform designed for fast-growing, global companies. It streamlines core HR processes, payroll, performance, and talent management, featuring an intuitive UI to improve employee engagement and experience.",
    "color": "#EE164F",
    "categories": [
      "HR Software"
    ],
    "promotions": [],
    "popularity": 89
  },
  {
    "name": "Digit",
    "slug": "digittechnologiesinc",
    "website": "https://digit-software.com",
    "description": "Digit is the modern ERP for manufacturers and distributors. One AI native platform for production, inventory, warehouse, and ops. Deploys in days. Integrates with QuickBooks, Xero, Shopify, and more.",
    "color": "#00b3ff",
    "categories": [
      "ERP",
      "Supply Chain & Logistics",
      "B2B Marketplaces",
      "Commerce",
      "Analytics"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 89
  },
  {
    "name": "Sentaro",
    "slug": "sentaro",
    "website": "https://sentaro.com",
    "description": "AI Email Security Agents that learns and evolves faster than emerging cyberthreats, protecting every inbox in your business. Deploy Sentaro in minutes and start protecting your organization from sophisticated email threats.",
    "color": "#1F33DA",
    "categories": [
      "Artificial Intelligence",
      "Collaboration & Productivity",
      "Security",
      "B2B Marketplaces",
      "Governance, Risk, & Compliance"
    ],
    "promotions": [],
    "popularity": 87
  },
  {
    "name": "Voye Global",
    "slug": "voyeglobalconnectivityltd",
    "website": "https://voyedatapool.com/",
    "description": "Voye Data Pool is a global mobile data solution for companies with travelling employees and connected devices. One shared monthly data pool replaces roaming charges, local SIMs, and fragmented plans.",
    "color": "#1000f3",
    "categories": [
      "HR",
      "Office Software"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 86
  },
  {
    "name": "Remote People",
    "slug": "remotepeople",
    "website": "https://remotepeople.com",
    "description": "Build world-class teams across 180+ countries. Leave the compliance, payroll and HR admin to us.",
    "color": "#FFFFFF",
    "categories": [
      "HR",
      "Payroll",
      "HR Software"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 86
  },
  {
    "name": "TestDriver.ai",
    "slug": "testdriverai3875",
    "website": "https://testdriver.ai",
    "description": "TestDriver reduces manual testing costs by 94% while performing tasks 3× faster than human-powered testing.",
    "color": "#B3D334",
    "categories": [
      "Artificial Intelligence",
      "Hosting Providers",
      "Development",
      "IT Infrastructure",
      "IT Management"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 83
  },
  {
    "name": "Niural AI",
    "slug": "niural",
    "website": "https://niural.com",
    "description": "Our PEO platform makes it easy to deliver enterprise-grade benefits to employees. Now earning rewards is easy, too. Refer your network to Niural and earn $250 for each referral, and up to $2,000 every time someone signs up.",
    "color": "#714DFF",
    "categories": [
      "Payroll",
      "HR Software",
      "B2B Marketplaces",
      "Artificial Intelligence"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 83
  },
  {
    "name": "VEA",
    "slug": "vea",
    "website": "https://vea.ai",
    "description": "VEA is an AI powered business management platform for solopreneurs and small businesses. One dashboard for customer management, invoicing, work orders, scheduling, tasks, and AI analytics. $24.95/user/month. No contracts.",
    "color": "#0D5161",
    "categories": [
      "Analytics",
      "Office Software",
      "Customer Service",
      "ERP",
      "Collaboration & Productivity"
    ],
    "promotions": [],
    "popularity": 82
  },
  {
    "name": "Prescient Security",
    "slug": "prescientsecurity",
    "website": "https://prescientsecurity.com",
    "description": "Prescient Security is a Global Top 20 Independent Audit and Penetration Testing Company, delivering unparalleled quality in audits, attestations, and certifications, across 25+ frameworks, such as SOC, ISO, HITRUST, ensuring excellence and client success.",
    "color": "#6258a6",
    "categories": [],
    "promotions": [],
    "popularity": 80
  },
  {
    "name": "Clutch",
    "slug": "clutch",
    "website": "https://clutch.co",
    "description": "Clutch matches B2B buyers with the right agency for their projects. We enable our Affiliates to share a unique link to the Clutch Matching Engine and earn a commission for every successful buyer-agency pairing.",
    "color": "#17313b",
    "categories": [
      "Marketing",
      "Sales",
      "B2B Marketplaces"
    ],
    "promotions": [],
    "popularity": 78
  },
  {
    "name": "Parim Workforce Software",
    "slug": "parimworkforcesoftware",
    "website": "https://www.parim.co",
    "description": "Parim is a modern workforce management platform for shift-based industries with bolt on sector specific features for security; events; healthcare and stadia",
    "color": "#00BEFF",
    "categories": [
      "Vertical Industry Software",
      "Office Software",
      "Collaboration & Productivity",
      "Security",
      "HR Software"
    ],
    "promotions": [],
    "popularity": 73
  },
  {
    "name": "Auware by Buyist",
    "slug": "buyist",
    "website": "https://www.auware.com",
    "description": "Unlike a page builder, Auware auto-builds audience-specific landing pages with targeted headlines, features, FAQs, and reviews for each persona. Choose your format, audiences & voice. Fine-tune with the inline editor. Measure with real-time dashboards.",
    "color": "#000000",
    "categories": [
      "B2B Marketplaces",
      "Content Management",
      "Design",
      "Commerce",
      "Development"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 67
  },
  {
    "name": "ExpertEx",
    "slug": "expertex803",
    "website": "https://expertex.ai",
    "description": "ExpertEx is the ultimate multimedia AI studio for creators & firms. Generate high-fidelity text, images, videos, and voiceovers in one place. Scale your content 10x faster with our AI growth engine. Join now for a premium 40% commission rate.",
    "color": "#0F172A",
    "categories": [
      "Content Management",
      "Design",
      "Artificial Intelligence",
      "Marketing",
      "Digital Advertising"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 59
  },
  {
    "name": "Springbolt ID",
    "slug": "springbolt",
    "website": "https://www.lead.springbolt.app/",
    "description": "Turn website visitors into named, verified contacts with email, company, title, and 37+ data points. Tracking their every move in your website.",
    "color": "#00b3ff",
    "categories": [
      "B2B Marketplaces",
      "Marketing",
      "Sales",
      "Analytics"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 58
  },
  {
    "name": "Planday",
    "slug": "planday",
    "website": "https://www.planday.com",
    "description": "Planday is a workforce management and smart scheduling platform that helps businesses run smoother, with shift planning, team management, and operations all in one place.",
    "color": "#00b3ff",
    "categories": [
      "Office Software",
      "Payroll",
      "HR Software",
      "Collaboration & Productivity",
      "HR"
    ],
    "promotions": [],
    "popularity": 56
  },
  {
    "name": "LucroVox",
    "slug": "lucrovox",
    "website": "https://lucrovox.com/ambassadors",
    "description": "Your audience includes local service businesses losing $2,500+/week to missed calls. LucroVox answers 24/7 in 500ms — easy sell. Affiliates: 40% M1 + 25% M2-4. Ambassadors: 30%/20%/10% lifetime. 90-day cookie.",
    "color": "#2E1065",
    "categories": [
      "Customer Service",
      "Collaboration & Productivity",
      "Artificial Intelligence",
      "Sales"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 43
  },
  {
    "name": "Stratos Development Group",
    "slug": "stratos",
    "website": "https://www.stratosdevgroup.com",
    "description": "Stratos is a managed service provider that specializes in custom software development.",
    "color": "#000000",
    "categories": [
      "Vertical Industry Software",
      "Hosting Providers",
      "CAD & PLM Software",
      "IT Infrastructure",
      "ERP"
    ],
    "promotions": [],
    "popularity": 40
  },
  {
    "name": "Pingtree",
    "slug": "pingtreellc",
    "website": "https://pingtree.com",
    "description": "Pingtree helps you turn clicks, calls, and form fills into revenue. Capture every lead, send it to the right buyer automatically, and see exactly which campaigns make you money. One platform for agencies, lead sellers, and media buyers.",
    "color": "#0C1525",
    "categories": [
      "Vertical Industry Software",
      "B2B Marketplaces",
      "Sales",
      "Analytics",
      "IT Infrastructure"
    ],
    "promotions": [],
    "popularity": 39
  },
  {
    "name": "Arbor",
    "slug": "arbor",
    "website": "https://www.joinarbor.com/business",
    "description": "Arbor is a free service platform that lowers and protects the price everyday businesses pay for energy completely risk free",
    "color": "#16680D",
    "categories": [
      "Sales",
      "Customer Service",
      "Artificial Intelligence",
      "Marketing",
      "B2B Marketplaces"
    ],
    "promotions": [],
    "popularity": 37
  },
  {
    "name": "Plansom",
    "slug": "plansom",
    "website": "https://plansom.com/",
    "description": "Plansom turns any proposal, SOW, Call Recording Summary, etc. into SMART goals and a strategy execution plan in sixty seconds. Teams use Plansom to align on what matters, prioritize the work that moves outcomes and see where execution is breaking down.",
    "color": "#0D1B4F",
    "categories": [
      "Artificial Intelligence",
      "Collaboration & Productivity"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 32
  },
  {
    "name": "BetterLife Real Estate Funding",
    "slug": "betterliferealestatefundinginc",
    "website": "https://betterliferef.com",
    "description": "BetterLife Real Estate Funding provides fast, flexible lending for real estate investors.",
    "color": "#3AA4DC",
    "categories": [
      "Accounting",
      "Sales"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 28
  },
  {
    "name": "Bread & Butter IO Inc.",
    "slug": "breadbutterioinc",
    "website": "https://breadbutter.io",
    "description": "Bread & Butter sits between your analytics and your CRM — giving demand gen and revenue teams the intelligence to prime the pipeline, act on high-intent visitors, and hand off sales-ready leads without adding headcount.",
    "color": "#00b3ff",
    "categories": [
      "Collaboration & Productivity",
      "Marketing",
      "Sales",
      "Content Management",
      "Digital Advertising"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 27
  },
  {
    "name": "LettrLabs",
    "slug": "lettrlabs",
    "website": "https://lettrlabs.com",
    "description": "LettrLabs is an automated direct mail platform designed to target, segment, automate and measure results of campaigns. We empower organizations to connect with their clients through personalized, handwritten mailers that leave a lasting impression using automations that make direct mail as easy as digital.",
    "color": "#000000",
    "categories": [],
    "promotions": [],
    "popularity": 26
  },
  {
    "name": "P3MO Ltd",
    "slug": "p3mo",
    "website": "https://p3mo.io",
    "description": "Engage in a co-sell with P3MO the execution hub that connects board-level strategy to delivery. RAID, planning, finance, resourcing and automated board reporting in one platform.",
    "color": "#FF5100",
    "categories": [
      "Office Software",
      "Governance, Risk, & Compliance",
      "Analytics",
      "Artificial Intelligence",
      "B2B Marketplaces"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 21
  },
  {
    "name": "Zedonk",
    "slug": "zedonk",
    "website": "https://zedonk.us/",
    "description": "Zedonk is a 360 degree fashion ERP platform, TRUSTED BY 1000s of BRANDS and SHOWROOMS ACROSS 45 COUNTRIES. OUR COMPREHENSIVE FASHION SOFTWARE SOLUTION EMPOWERS YOU TO STREAMLINE OPERATIONS AND DRIVE GROWTH IN THE DYNAMIC WORLD OF FASHION.",
    "color": "#f55a0d",
    "categories": [
      "Supply Chain & Logistics",
      "ERP"
    ],
    "promotions": [],
    "popularity": 17
  },
  {
    "name": "Unleashed Software by The Access Group",
    "slug": "unleashedsoftwarebytheaccessgroup",
    "website": "https://www.unleashedsoftware.com",
    "description": "Unleashed is cloud-based inventory management software built for product businesses (wholesalers, distributors, and manufacturers) who've outgrown spreadsheets or basic accounting software. We're a strong fit for businesses managing multiple SKUs, warehouses, or stock across sales channels, and for those needing accurate costing and margin visibility as they scale. We integrate natively with Xero, QuickBooks, and platforms like Shopify, so customers don't need to rip out their existing systems.",
    "color": "#E5173F",
    "categories": [],
    "promotions": [],
    "popularity": 16
  },
  {
    "name": "Ploy.ai",
    "slug": "ployai",
    "website": "https://Ploy.ai",
    "description": "Software designed to help modern teams improve their day-to-day work.",
    "color": "#00b3ff",
    "categories": [],
    "promotions": [],
    "popularity": 10
  },
  {
    "name": "AFTRDRK",
    "slug": "aftrdrk",
    "website": "https://aftrdrk.com",
    "description": "AFTRDRK's DRK Web Surveillance (DWS) platform gives you real cyber threat intelligence signals that come from the Deep and Dark Web.",
    "color": "#060606",
    "categories": [
      "IT Management",
      "IT Infrastructure",
      "Governance, Risk, & Compliance",
      "Data Privacy",
      "Security"
    ],
    "promotions": [
      "free_trial",
      "discount"
    ],
    "popularity": 7
  }
]
